// @ts-nocheck
/// <reference path="../../../../../RcWebModels/RCUserModel.cs.d.ts" />
/// <reference path="../../../../../RcWebModels/CustomAttributes.cs.d.ts" />
import * as React from 'react';
import { RCUtils } from './../../RCUtils';
import { PopupWindow } from '../sharedcomponents/PopupWindow';
import * as RCNGWindow from '../sharedcomponents/ConfirmationWindow';
import $ from 'jquery';
import cloneDeep from 'lodash/cloneDeep';
import isEqual from 'lodash/isEqual';
import queryString from 'query-string';
import { isNullOrUndefined } from 'util';
import * as Autosuggest from 'react-autosuggest';
import Select from 'react-select';
import "../../../node_modules/react-select/dist/react-select.css";
import { ReeferStatusGrid } from '../childcomponents/ReeferStatusGrid';
import { GensetStatusGrid } from '../childcomponents/GensetStatusGrid';
import { DryStatusGrid } from '../childcomponents/DryStatusGrid';
import { DryStatusSSRMGrid } from '../childcomponents/DryStatusSSRMGrid';

import { ChassisStatusGrid } from '../childcomponents/ChassisStatusGrid';
import ReeferCallout from '../../actions/ReeferCallout';
import { ReeferHistoryGrid } from './ReeferHistoryGrid';
import { GensetHistoryGrid } from './GensetHistoryGrid';
import { DryHistoryGrid } from './DryHistoryGrid';
import { ChassisHistoryGrid } from './ChassisHistoryGrid';
import UserRights from '../../actions/UserRights';
import deletepng from '../../images/delete.png';
import uniq from 'lodash/uniq';
import { ContextMenu, MenuItem, ContextMenuTrigger } from "react-contextmenu";
import { AssetSearch } from './../../../src/actions/CCWizardEmpties';  //'../../actions/CCWizardEmpties.js'
import forIn from 'lodash/forIn';

var Config: any = require('../../Config.json');

interface SearchState {
    Oemtypes: server.vRefOEMTypeUIModel[];
    RefCountry: server.RefCountryModel[];
    RefGeofences: string[];
    //RefVessels: string[];
    RefVessels: server.vesselsList[]; //WI-26881
    Filters: server.ReeferSearchFilters;
    CustomAttributes: server.CustomAttributes[];
    CustomAttributesHtml: any;
    suggestionsFenceId: any[],
    suggestionsVesselId: any[],//WI-26881
    suggestionsVoyage: any[],//WI-26881
    suggestionsCalls: any[],//WI-26881
    targetId: string,
    stayOpen: boolean;
    disabled: boolean;
    removeSelected: boolean;
    rtl: boolean;
    selectedOperator: any;
    SerachState: string;
    SearchName: string;
    IsDefaultSearch: boolean;
    SelectedSearch: string;
    SearchNamesList: server.SearchNamesResults[];
    AssetTypes: any[];
    SelectedSearchControls: any[];
    AssetStates: any[];
    CargoCareProfiles: any[];
    DefaultSearchData: any[];
    Pols: any[];//RCNG5588
    Pods: any[];//RCNG5588
}

var IsTriggered = false;
var self;
var customAttributesInfo;
var selectedCustomAttributes;
var modelYear;
var modelYearMin;
var modelYearMax;
var DisableFields = false;
var SelectedUserPreferenceId = 0;
//var defaultAssetTypes;
var selectedSearchParams = null;
var defaultSearch = false;
var IsDefaultCheckboxClicked = false;
var IsFromLoadState = false;
var DefaultCheckBoxState = false;
var isFirefox;
var hasReefers: boolean = false;
var hasGensets: boolean = false;
var hasDrys: boolean = false;
var hasChassis: boolean = false;
var assetCount = 0;
var showOem: boolean = false;
var showInvState: boolean = false;
//var windowTitle = "";
const mathOperators = [
    { Operator: "=", value: 1 },
    { Operator: "<", value: 2 },
    { Operator: "<=", value: 3 },
    { Operator: ">", value: 4 },
    { Operator: ">=", value: 5 },
    { Operator: ">", value: 6 },
    { Operator: "<>", value: 7 },
];
const assetStates = [
    { label: "Active", value: 'A' },
    { label: "Disconnected", value: 'D' },
    { label: "Retired", value: 'R' },
];
export class AdvanceSearch extends React.Component<any, SearchState> {
    constructor(props: any) {
        super(props);
        IsTriggered = false;
        customAttributesInfo = {};
        selectedCustomAttributes = {};

        var assetTypes = this.loadAssetTypes();
        //defaultAssetTypes = assetTypes.join(",");
        this.GetSelectedSearchControls();
        var filter: server.ReeferSearchFilters = {
            SelectedOem: '', SelectedCountry: '', SelectedGeofence: '', SelectedGeofenceInside: '', SelectedInterval: '', SelectedReefer: '', SelectedAssetStates: JSON.parse(sessionStorage.getItem('customerDetails')).InventoryState,///RCNG-70,
            SelectedVesselCode: '', StatusFilters: [], AllReefers: '', CustomAttributeFilters: customAttributesInfo, SelectedAssetTypes: '', SelectedBookingNumber: ''
            , SelectedVesselCD: '', SelectedVoyage: '', SelectedCall: ''//WI-26881
            , SelectedCargoCareProfiles: '', SelectedPol: '', SelectedPod: '', SelectedCTProfileIds: []  //RCNG5588
        };

        if (this.props.previousState != null && this.props.previousState != undefined) {
            if (this.props.previousState.SelectedAssetTypes != null) {
                filter.SelectedAssetTypes = this.props.previousState.SelectedAssetTypes;
            }

            if (this.props.previousState.SelectedAssetStates != null && this.props.previousState.SelectedAssetStates != "") { //RCNG-781
                filter.SelectedAssetStates = this.props.previousState.SelectedAssetStates;
            }

            if (this.props.previousState.SelectedOem != null) {
                filter.SelectedOem = this.props.previousState.SelectedOem;
            }

            if (this.props.previousState.SelectedCountry != null) {
                filter.SelectedCountry = this.props.previousState.SelectedCountry;
            }

            if (this.props.previousState.SelectedGeofence != null) {
                filter.SelectedGeofence = this.props.previousState.SelectedGeofence;
            }
            //WI-26881:Start
            if (this.props.previousState.SelectedVesselCD != null) {
                filter.SelectedVesselCD = this.props.previousState.SelectedVesselCD;
            }
            if (this.props.previousState.SelectedVoyage != null) {
                filter.SelectedVoyage = this.props.previousState.SelectedVoyage;
            }
            if (this.props.previousState.SelectedCall != null) {
                filter.SelectedCall = this.props.previousState.SelectedCall;
            }
            //WI-26881:End
            if (this.props.previousState.SelectedGeofenceInside != null) {
                filter.SelectedGeofenceInside = this.props.previousState.SelectedGeofenceInside;
            }

            if (this.props.previousState.SelectedInterval != null) {
                filter.SelectedInterval = this.props.previousState.SelectedInterval;
            }

            if (this.props.previousState.SelectedReefer != null) {
                filter.SelectedReefer = this.props.previousState.SelectedReefer;
            }

            if (this.props.previousState.SelectedVesselCode != null) {
                filter.SelectedVesselCode = this.props.previousState.SelectedVesselCode;
            }

            if (this.props.previousState.SelectedBookingNumber != null) {
                filter.SelectedBookingNumber = this.props.previousState.SelectedBookingNumber;
            }

            if (this.props.previousState.SelectedCargoCareProfiles != null) {//RCNG-3392
                filter.SelectedCargoCareProfiles = this.props.previousState.SelectedCargoCareProfiles;
            }

            if (this.props.previousState.StatusFilters != null && this.props.previousState.StatusFilters.length > 0) {
                filter.StatusFilters = this.props.previousState.StatusFilters;
            }

            if (this.props.previousState.AllReefers != null) {
                filter.AllReefers = this.props.previousState.AllReefers;
            }
            if (this.props.previousState.SelectedPol != null) {
                filter.SelectedPol = this.props.previousState.SelectedPol;
            }
            if (this.props.previousState.SelectedPod != null) {
                filter.SelectedPod = this.props.previousState.SelectedPod;
            }

        }

        this.state = {
            Oemtypes: [], RefCountry: [], RefGeofences: [], RefVessels: [], //WI-26881
            suggestionsFenceId: [], suggestionsVesselId: [], suggestionsVoyage: [], suggestionsCalls: [],//WI-26881
            targetId: '', Filters: filter, CustomAttributes: this.props.CustomAttributes, CustomAttributesHtml: '', selectedOperator: '=',
            SerachState: 'SearchOnly', SearchName: '', IsDefaultSearch: false, SelectedSearch: 'Saved Searches', SearchNamesList: [], AssetTypes: assetTypes,
            stayOpen: false, disabled: false, removeSelected: false, rtl: false, AssetStates: assetStates, SelectedSearchControls: [],
            CargoCareProfiles: [], DefaultSearchData: [], Pols: [], Pods: [] //RCNG5588

        };
        self = this;

        var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/common/GetGeofences')
        RCUtils.fetchRetry(request)
            .then(RCUtils.handleResponse)
            .then(response => response.json() as Promise<any>)
            .then(data => {
                if (data.length > 0) {
                    var fenceData = data.map(fence => fence.Tag);
                    this.setState({ RefGeofences: fenceData });
                }
            });
        //WI-26881:Start
        var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/common/Getvessels')
        RCUtils.fetchRetry(request)
            .then(RCUtils.handleResponse)
            .then(response => response.json() as Promise<any>)
            .then(data => {
                if (data.length > 0) {
                    //var VesselData = data.map(fence => fence.VesselCd);
                    //var uniqueVesselData = uniq(VesselData);
                    this.setState({ RefVessels: data });
                }
            });
        //WI-26881:End
        var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/common/OemTypes')
        RCUtils.fetchRetry(request)
            .then(RCUtils.handleResponse)
            .then(response => response.json() as Promise<any>)
            .then(data => {
                this.setState({ Oemtypes: data });
            });

        var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/common/RefCountry')
        RCUtils.fetchRetry(request)
            .then(RCUtils.handleResponse)
            .then(response => response.json() as Promise<any>)
            .then(data => {
                this.setState({ RefCountry: data });
            });

        //var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/CargoCareProfile/GetCargoCareCustomerProfiles');
        //fetch(request)
        //    .then(RCUtils.handleError)
        //    .then(response => response.json() as Promise<any[]>)
        //    .then(data => {
        //        this.setState({ CargoCareProfiles: data });
        //    });

        if (this.props.CustomAttributes != null && this.props.CustomAttributes != undefined && this.props.CustomAttributes.length > 0) {
            this.renderAttributesHtml();
        }

        isFirefox = /Firefox[\/\s](\d+\.\d+)/.test(navigator.userAgent);
    }

    loadAssetTypes() {
        var assetTypes = [];
        var customer = JSON.parse(sessionStorage.getItem('customerDetails'));
        if (customer != null && customer != undefined) {
            if (customer.HasDry)
                assetTypes.push('Dry');
            if (customer.HasGenset)
                assetTypes.push('Genset');
            if (customer.HasReefer)
                assetTypes.push('Reefer');
            if (customer.HasChassis)
                assetTypes.push('Chassis');
        }
        return assetTypes;
    }

    componentWillReceiveProps(nextProps: any) {
        if (nextProps.CustomAttributes != null && nextProps.CustomAttributes != undefined && nextProps.CustomAttributes.length > 0) {
            this.setState({ CustomAttributes: nextProps.CustomAttributes }, () => this.renderAttributesHtml());
        }
    }

    componentDidMount() {
        assetCount = 0;
        var customer = JSON.parse(sessionStorage.getItem('customerDetails'));
        if (customer != null && customer != undefined) {
            if (customer.GroupsRights != null && customer.GroupsRights != undefined) { // RCNG 940
                if (customer.HasReefer && customer.GroupsRights.includes('Reefers')) {
                    assetCount += 1;
                    showOem = true;
                    showInvState = true;
                    hasReefers = true
                }
                if (customer.HasGenset && customer.GroupsRights.includes('Gensets')) {
                    assetCount += 1;
                    showOem = true;
                    showInvState = true;
                    hasGensets = true;
                }
                if (customer.HasDry && customer.GroupsRights.includes('Dry')) {
                    assetCount += 1;
                    showInvState = true;
                    hasDrys = true;
                }
                if (customer.HasChassis && customer.GroupsRights.includes('Chassis')) {
                    assetCount += 1;
                    hasChassis = true;
                }
            }
        }
        this.LoadUserPreferenceSearchNames(this.state.SearchName);
        this.loadCargoCareProfiles();
        this.loadPols();//RCNG5588
        this.loadPods();//RCNG5588
        /* WI 24157 commented
        //var checkDefaulSearchEnable = JSON.parse(sessionStorage.getItem('UserInfo')).ShowSaveSearchOnLoad;
        //if (checkDefaulSearchEnable)
        //    this.GetDefaultSearchParams();
        //else
        //    setTimeout(() => { this.hideGlobalLoader() }, 5000); */
        var params = queryString.parse(window.location.search);
        if (!isNullOrUndefined(params.assetId)) {
            $("#globalLoader").show();
            var filters = self.state.Filters;
            filters.SelectedReefer = params.assetId;

            setTimeout(() => { self.LoadGetAllAssetTypeData() }, 5000);
        }
        else {
            var searchState = sessionStorage.getItem("DefaultSearch");
            if (searchState == "enabled")
                this.GetDefaultSearchParams();
            //else {
            //    this.ClearFilter();
            //}
        }

        $("#ddlSavedSearch").show();
        $("#txtSearchName").hide();
    }

    hideGlobalLoader() {
        $("#globalLoader").hide();
    }

    GetDefaultSearchParams() {
        var functionID = 1;
        var url = Config.ApiBaseUrl + '/api/User/GetDefaultSearchParams?FunctionId=' + functionID;
        var request = RCUtils.FetchRequest(url);
        RCUtils.fetchRetry(request)
            .then(RCUtils.handleResponse)
            .then(response => response.json() as Promise<any>)
            .then(data => {
                if (data != null && data != undefined) {
                    this.setState({ DefaultSearchData: data });
                    var dashboardPreferenceId: any = sessionStorage.getItem('DashboardPreferenceId');//this.props.dashboardPreferenceId;
                    var defaultPreference: any = data.filter(x=>x.DashboardPreferenceId == dashboardPreferenceId);
                    if(defaultPreference != undefined && defaultPreference.length>0) {
                        $("#globalLoader").show();
                        var userPreferences = JSON.parse(defaultPreference[0].PreferenceData);
                        this.FillDefaultSearchParams(userPreferences);
                        SelectedUserPreferenceId = defaultPreference[0].UserPreferenceId;
                        selectedSearchParams = userPreferences;
                        this.setState({ SelectedSearch: JSON.parse(JSON.stringify(defaultPreference[0].SearchName)), IsDefaultSearch: defaultPreference[0].DefaultSearch }, () => { self.loadDefaultSavedSearch(); });
        
                        DefaultCheckBoxState = defaultPreference[0].DefaultSearch;
                        IsFromLoadState = defaultPreference[0].DefaultSearch;
                        sessionStorage.setItem('DefaultSearch', 'enabled');
                    }                            
                }
                else
                    setTimeout(() => { this.hideGlobalLoader() }, 5000);
            });
    }

    static applyAdvanceSearchPreferences(searchPreference: any, dashboardPreferenceId) {
        if(self != undefined) {           
            self.RestoreDefaultSearch(dashboardPreferenceId, searchPreference);
        }
        else
            $("#globalLoader").hide();
    }
    
    RestoreDefaultSearch(dashboardPreferenceId : any, searchPreference: any){
        var defaultPreference: any = self.state.DefaultSearchData.filter(x=>x.DashboardPreferenceId == dashboardPreferenceId);
        if(defaultPreference != undefined && defaultPreference.length>0) {
            //$("#globalLoader").show();
            var userPreferences = JSON.parse(defaultPreference[0].PreferenceData);
            this.FillDefaultSearchParams(userPreferences);
            SelectedUserPreferenceId = defaultPreference[0].UserPreferenceId;
            selectedSearchParams = userPreferences;
            this.setState({ SelectedSearch: JSON.parse(JSON.stringify(defaultPreference[0].SearchName)), IsDefaultSearch: defaultPreference[0].DefaultSearch }, () => { self.loadDefaultSavedSearch(); });
        
            DefaultCheckBoxState = defaultPreference[0].DefaultSearch;
            IsFromLoadState = defaultPreference[0].DefaultSearch;
            //sessionStorage.setItem('DefaultSearch', 'enabled');
        } 
        else {
            this.FillDefaultSearchParams(searchPreference);
            SelectedUserPreferenceId = 0;
            selectedSearchParams = "";
            DefaultCheckBoxState = false;
            this.setState({
                SearchName: '',
                IsDefaultSearch: DefaultCheckBoxState,
                SelectedSearch: 'Saved Searches'
            });
            IsFromLoadState = false;
            //sessionStorage.setItem('DefaultSearch', 'disabled');
            $("#globalLoader").hide();
        }
    }

    FillDefaultSearchParams(userPreference: any) {
        var filters = this.state.Filters;
        filters.AllReefers = userPreference.AllReefers;
        filters.SelectedCountry = userPreference.SelectedCountry;
        if (userPreference.SelectedGeofence != null && userPreference.SelectedGeofence != undefined)
            filters.SelectedGeofence = userPreference.SelectedGeofence;
        else
            filters.SelectedGeofence = "";
        filters.SelectedGeofenceInside = userPreference.SelectedGeofenceInside;
        filters.SelectedInterval = userPreference.SelectedInterval;
        if (userPreference.SelectedAssetTypes != null && userPreference.SelectedAssetTypes != undefined)
            filters.SelectedAssetTypes = userPreference.SelectedAssetTypes;
        else
            filters.SelectedAssetTypes = "";
        if (userPreference.SelectedAssetStates != null && userPreference.SelectedAssetStates != undefined && userPreference.SelectedAssetStates != "")//RCNG-70;
            filters.SelectedAssetStates = userPreference.SelectedAssetStates;
        else
            filters.SelectedAssetStates = JSON.parse(sessionStorage.getItem('customerDetails')).InventoryState;///RCNG-70;//RCNG-59
        filters.SelectedOem = userPreference.SelectedOem;
        filters.SelectedReefer = userPreference.SelectedReefer;
        filters.SelectedVesselCode = userPreference.SelectedVesselCode;
        filters.SelectedBookingNumber = userPreference.SelectedBookingNumber;
        filters.SelectedCargoCareProfiles = userPreference.SelectedCargoCareProfiles;//RCNG-3392
        filters.SelectedPol = userPreference.SelectedPol;
        filters.SelectedPod = userPreference.SelectedPod;

        //WI-26881:Start
        if (userPreference.SelectedVesselCD != null && userPreference.SelectedVesselCD != undefined)
            filters.SelectedVesselCD = userPreference.SelectedVesselCD;
        else
            filters.SelectedVesselCD = "";
        if (userPreference.SelectedVoyage != null && userPreference.SelectedVoyage != undefined)
            filters.SelectedVoyage = userPreference.SelectedVoyage;
        else
            filters.SelectedVoyage = "";
        if (userPreference.SelectedCall != null && userPreference.SelectedCall != undefined)
            filters.SelectedCall = userPreference.SelectedCall;
        else
            filters.SelectedCall = "";
        //WI-26881:End

        filters.StatusFilters = userPreference.StatusFilters;
        customAttributesInfo = userPreference.CustomAttributeFilters;
        selectedCustomAttributes = cloneDeep(customAttributesInfo);

        this.setState({ Filters: filters });
        this.BindCustomAttributesValues();
    }
    loadCargoCareProfiles() {
        var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/CargoCareProfile/GetCargoCareCustomerProfilesAdvanceSearch');
        fetch(request)
            .then(RCUtils.handleError)
            .then(response => response.json() as Promise<any[]>)
            .then(data => {
                this.setState({ CargoCareProfiles: data });
            });
    }
    //RCNG5588
    loadPols() {
        var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/CargoCareProfile/GetPOLDetails');
        fetch(request)
            .then(RCUtils.handleError)
            .then(response => response.json() as Promise<any[]>)
            .then(data => {
                this.setState({ Pols: data });
            });
    }
    loadPods() {
        var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/CargoCareProfile/GetPODDetails');
        fetch(request)
            .then(RCUtils.handleError)
            .then(response => response.json() as Promise<any[]>)
            .then(data => {
                this.setState({ Pods: data });
            });
    }
    
    LoadUserPreferenceSearchNames(searchName: any) {
        var url = Config.ApiBaseUrl + '/api/User/GetUserPreferenceSearchNames';
        var preferencedata = { UserID: 0, FunctionID: 1, Type: '' };
        var request = RCUtils.FetchRequest(url, { method: 'POST', body: JSON.stringify(preferencedata), headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
        RCUtils.fetchRetry(request)
            .then(RCUtils.handleResponse)
            .then(response => response.json() as Promise<any>)
            .then(data => {
                this.setState({ SearchNamesList: data }, () => { this.GetDataForNewlySavedUserPreference(searchName); });
            });

    }

    renderAttributesHtml() {
        this.setState({ CustomAttributesHtml: this.renderCustomAttributeHtml() });
    }
    MathOptionChange(event: React.FormEvent<HTMLSelectElement>, inputName: string) {

        var Value: string = event.currentTarget.value

        this.setState({
            selectedOperator: Value
        }, () => {
            inputName = inputName.replace(' ', '')
            delete customAttributesInfo[inputName];
            this.updateInput(inputName, modelYear);
        });
    }
    renderCustomAttributeHtml() {
        var renderAttributesHtml: any[] = [];
        if (this.state.CustomAttributes != null && this.state.CustomAttributes != undefined && this.state.CustomAttributes.length > 0) {
            $.each(this.state.CustomAttributes, function (i, val) {
                if (val.AttributeTypeCD == 'E') {
                    renderAttributesHtml.push(self.renderCustomAttributeDropDown(val.AttributeTypeEnumValsInfo, val.AttributeName));
                }
                else if (val.AttributeTypeCD == 'A') {
                    renderAttributesHtml.push(self.renderCustomAttributeTextBox(val.AttributeName));
                }
                else if (val.AttributeTypeCD == 'N') {
                    renderAttributesHtml.push(self.renderCustomAttributeMathOperatorTextBox(val.AttributeName, val.AttributeTypeNumericInfo));
                }
            });
        }

        return <div>
            {renderAttributesHtml}
        </div>;
    }

    renderCustomAttributeDropDown(AttributeTypeInfo: any[], inputName: string) {
        var inputControlName = inputName.replace(" ", "");
        return <div className='col-12 mb-2'>
            <select className='form-select ' id={'select' + inputControlName.toString().trim()} onChange={this.customAttributeDropDownChange.bind(this)}>
                <option value={inputName}>{inputName}</option>
                {
                    AttributeTypeInfo.map((atVal, index) =>
                        <option key={atVal.AttributeTypeEnumValsID + atVal.ValueShortName + index} value={atVal.ValueShortName}>{atVal.Value}</option>
                    )}
            </select>
        </div>;
    }

    renderCustomAttributeTextBox(inputName: string) {
        var inputControlName = inputName.replace(" ", "");
        return <div className='col-12 mb-2'>
            <div className='input-group'>
                <input type='text' className='form-control' id={'txt' + inputControlName.toString().trim()} placeholder={inputName} onChange={this.customAttributeTextChange.bind(this)} />
            </div>
        </div>
    }

    renderCustomAttributeMathOperatorTextBox(inputName: string, validationVal: any[]) {
        var inputControlName = inputName.replace(" ", "");
        var validationStrObj = validationVal[0];
        modelYearMin = validationStrObj["MinValue"];
        modelYearMax = validationStrObj["MaxValue"];
        if (validationStrObj != null && validationStrObj != "") {
            var validationStr = "This value must be a number greater than or equal to " + validationStrObj["MinValue"] + " and less than or equal to " + validationStrObj["MaxValue"] + ".";
        }
        return <div className="col-12 mb-2">
            <div className="input-group advance-modelyear">
               
                    <select id='MathOption' className='form-select' onChange={e => this.MathOptionChange(e, inputName)} >
                        {
                            mathOperators.map((atVal, index) =>
                                <option key={atVal.value} value={atVal.Operator}>{atVal.Operator}</option>
                            )}
                    </select>
               
                <input type='text' className='form-control' id={'txt' + inputControlName.toString().trim()} placeholder={inputName} onChange={this.customAttributeNumericTextChange.bind(this)} />
                    <label className="input-group-text" title={validationStr}>
                        <i className="fas fa-info"></i>
                    </label>
          
            </div>
        </div>
    }

    customAttributeDropDownChange(event: React.FormEvent<HTMLSelectElement>) {
        var inputName = event.currentTarget.id.split('select')[1];
        var inputValue = event.currentTarget.value;
        $('#select' + inputName).removeClass("fw-semibold");

        if (customAttributesInfo.hasOwnProperty(inputName)) {
            var propertyInput = inputValue.replace(' ', '')
            if (propertyInput == inputName) {
                delete customAttributesInfo[inputName];
            }
            else {
                customAttributesInfo[inputName] = inputValue;
                if ($('#select' + inputName).hasClass('fw-semibold') == false)
                    $('#select' + inputName).addClass("fw-semibold");
            }
        }
        else {
            customAttributesInfo[inputName] = inputValue;
            $('#select' + inputName).addClass("fw-semibold");
        }
    }

    customAttributeNumericTextChange(event: React.FormEvent<HTMLInputElement>) {
        var Value: string = event.currentTarget.value.trim();
        var inputName = event.currentTarget.id.split('txt')[1];
        const IsMatch = /^[0-9]*$/;
        if (IsMatch.test(Value))
            inputValue = Value;
        else {
            event.currentTarget.value = "";
            inputValue = "";
            modelYear = "";
            customAttributesInfo[inputName] = "";
            return;
        }
        //var inputName = event.currentTarget.id.split('txt')[1];
        var inputValue = event.currentTarget.value;
        modelYear = event.currentTarget.value;
        //var Value: string = event.currentTarget.value.trim();
        this.updateInput(inputName, inputValue);

    }

    customAttributeTextChange(event: React.FormEvent<HTMLInputElement>) {
        var Value: string = event.currentTarget.value.trim();
        var inputName = event.currentTarget.id.split('txt')[1];
        const IsMatch = /^[a-zA-Z0-9]*$/;
        if (IsMatch.test(Value))
            inputValue = Value;
        else {
            event.currentTarget.value = "";
            inputValue = "";
            customAttributesInfo[inputName] = "";
            return;
        }
        //var inputName = event.currentTarget.id.split('txt')[1];
        var inputValue = event.currentTarget.value.trim();
        //var Value: string = event.currentTarget.value.trim();
        this.updateTextInput(inputName, inputValue);

    }

    updateTextInput(inputName: string, inputValue: string) {
        $('#txt' + inputName).addClass("fw-semibold");
        if (customAttributesInfo.hasOwnProperty(inputName)) {
            if (inputValue != null && inputValue != undefined && inputValue != '') {
                customAttributesInfo[inputName] = inputValue;
            }
            else {
                delete customAttributesInfo[inputName];
            }
        }
        else {
            customAttributesInfo[inputName] = inputValue;
        }
    }

    updateInput(inputName: string, inputValue: string) {
        $('#txt' + inputName).addClass("fw-semibold");
        if (customAttributesInfo.hasOwnProperty(inputName)) {
            if (inputValue != null && inputValue != undefined && inputValue != '') {
                customAttributesInfo[inputName] = this.state.selectedOperator + "&Cum&" + inputValue;
                // customAttributesInfo[inputName] = inputValue;
            }
            else {
                delete customAttributesInfo[inputName];
            }
        }
        else {
            if (inputValue != null && inputValue != undefined && inputValue != '')
                customAttributesInfo[inputName] = this.state.selectedOperator + "&Cum&" + inputValue;
            //customAttributesInfo[inputName] =  inputValue;
        }

    }

    InsideGeofencechange(event: React.FormEvent<HTMLSelectElement>) {
        var filters = this.state.Filters;
        $('#selectInsideGeofence').removeClass("fw-semibold");

        var Value: string = event.currentTarget.value;
        if (Value == "Geofence Status") {
            filters.SelectedGeofenceInside = "";
        }
        else {
            if ($('#selectInsideGeofence').hasClass('fw-semibold') == false)
                $('#selectInsideGeofence').addClass("fw-semibold");
            filters.SelectedGeofenceInside = Value;
        }

        this.setState({
            Filters: filters
        });
    }

    Vesselcodechange(event: React.FormEvent<HTMLInputElement>) {
        var filters = this.state.Filters;
        $(this).addClass("fw-semibold");
        var Value: string = event.currentTarget.value;
        filters.SelectedVesselCode = Value;
        this.setState({
            Filters: filters
        });
    }

    onSuggestionsFetchRequested = ({ value }) => {
        this.setState({
            suggestionsFenceId: this.getFenceNameSuggestions(value)
        });
    };
    getFenceNameSuggestions(value) {
        var geofences = this.state.RefGeofences;
        var targetValue = this.state.targetId;
        var inputValue = value.trim().toLowerCase();
        var inputLength = inputValue.length;
        return inputLength === 0 ? [] : geofences.filter(tag =>
            tag.toLowerCase().slice(0, inputLength) === inputValue
        );
    };
    onSuggestionsClearRequested = () => {
        this.setState({
            suggestionsFenceId: []
        });
    };
    onChangeFenceId = (event, { newValue }) => {
        var filters = this.state.Filters;
        filters.SelectedGeofence = newValue;
        $('#geofenceID').addClass("fw-semibold");

        this.setState({
            Filters: filters,
            targetId: event.target.id
        });
    };
    renderSuggestion(suggestion) {
        return <span>{suggestion}</span>;
    }

    getSuggestionValue(suggestion) {
        return suggestion;
    }
    //WI-26881:Start
    onSuggestionsFetchRequestedforvessel = ({ value }) => {
        this.setState({
            suggestionsVesselId: this.getvesselNameSuggestions(value)
        });
    };
    getvesselNameSuggestions(value) {
        //var vessels = this.state.RefVessels;
        var VesselData = this.state.RefVessels.map(fence => fence.VesselCd);
        var vessels = uniq(VesselData);
        var targetValue = this.state.targetId;
        var inputValue = value.trim().toLowerCase();
        var inputLength = inputValue.length;
        return inputLength === 0 ? [] : vessels.filter(tag =>
            tag.toLowerCase().slice(0, inputLength) === inputValue
        );
    };
    onSuggestionsClearRequestedforvessel = () => {
        this.setState({
            suggestionsVesselId: []
        });
    };
    onChangeVesselId = (event, { newValue }) => {
        var filters = this.state.Filters;
        filters.SelectedVesselCD = newValue;
        filters.SelectedVoyage = '';
        filters.SelectedCall = '';
        //$('#vesselID').addClass("fw-semibold");

        this.setState({
            Filters: filters,
            targetId: event.target.id
        });
        this.setState({
            suggestionsVoyage: this.getvoyageNameSuggestions(newValue)
        });
    };
    onChangcall = (event, { newValue }) => {
        var filters = this.state.Filters;
        filters.SelectedCall = newValue;
        //$('#vesselID').addClass("fw-semibold");

        this.setState({
            Filters: filters,
            targetId: event.target.id
        });
    };
    renderSuggestionVesselvalue(suggestion) {
        return <span>{suggestion}</span>;
    }

    getSuggestionVesselValue(suggestion) {
        return suggestion;
    }
    onSuggestionsFetchRequestedforvoyage = ({ value }) => {
        this.setState({
            suggestionsVoyage: this.voyageNameSuggestions(value)
        });
    };
    onSuggestionsFetchRequestedforcall = ({ value }) => {
        this.setState({
            suggestionsCalls: this.callSuggestions(value)
        });
    };
    callSuggestions(value) {
        if (this.state.Filters.SelectedVesselCD != "" && this.state.Filters.SelectedVesselCD != null && this.state.Filters.SelectedVoyage != "" && this.state.Filters.SelectedVoyage != null) {
            var VesselData = this.state.RefVessels;
            var targetValue = this.state.targetId;
            var inputValue = value.trim().toLowerCase();
            var inputLength = inputValue.length;
            var test = inputLength === 0 ? [] : VesselData.filter(tag => tag.VesselCd === this.state.Filters.SelectedVesselCD
                && tag.VoyageNum === this.state.Filters.SelectedVoyage && tag.CallNum.toLowerCase().slice(0, inputLength) === inputValue
            );
            //return test;
            return uniq(test.map(fence => fence.CallNum));
        }
        else
            return [];
    };
    voyageNameSuggestions(value) {
        if (this.state.Filters.SelectedVesselCD != "" && this.state.Filters.SelectedVesselCD != null) {
            var VesselData = this.state.RefVessels;
            //var vessels = uniq(VesselData);
            //var vessels = this.state.RefVessels;
            var targetValue = this.state.targetId;
            var inputValue = value.trim().toLowerCase();
            var inputLength = inputValue.length;
            var test = inputLength === 0 ? [] : VesselData.filter(tag => tag.VesselCd === this.state.Filters.SelectedVesselCD
                && tag.VoyageNum.toLowerCase().slice(0, inputLength) === inputValue
            );
            //return test;
            return uniq(test.map(fence => fence.VoyageNum));
        }
        else
            return [];
    };
    getvoyageNameSuggestions(value) {
        //var VesselData = this.state.RefVessels.map(fence => fence.VesselCd);
        var VesselData = this.state.RefVessels;
        //var vessels = uniq(VesselData);
        //var vessels = this.state.RefVessels;
        var targetValue = this.state.targetId;
        var inputValue = value.trim().toLowerCase();
        var inputLength = inputValue.length;
        var test = inputLength === 0 ? [] : VesselData.filter(tag =>
            tag.VesselCd.toLowerCase().slice(0, inputLength) === inputValue
        );
        //return test;
        return uniq(test.map(fence => fence.VoyageNum));
        //return (inputLength === 0 || this.state.RefVessels == null) ? [] : this.state.vesselData.PortOfDepartureList.filter(PortOfDeparture =>
        //    PortOfDeparture.toLowerCase().slice(0, inputLength) === inputValue
        //);
    };
    getcallSuggestions(value) {
        var VesselData = this.state.RefVessels;
        var targetValue = this.state.targetId;
        var inputValue = value.trim().toLowerCase();
        var inputLength = inputValue.length;
        var test = inputLength === 0 ? [] : VesselData.filter(tag => tag.VesselCd === this.state.Filters.SelectedVesselCD
            && tag.VoyageNum.toLowerCase().slice(0, inputLength) === inputValue
        );
        return uniq(test.map(fence => fence.CallNum));
    };
    onSuggestionsClearRequestedforvoyage = () => {
        this.setState({
            suggestionsVoyage: []
        });
    };
    onSuggestionsClearRequestedforcall = () => {
        this.setState({
            suggestionsCalls: []
        });
    };
    onChangevoyage = (event, { newValue }) => {
        var filters = this.state.Filters;
        filters.SelectedVoyage = newValue;
        //$('#vesselID').addClass("fw-semibold");
        filters.SelectedCall = '';
        this.setState({
            Filters: filters,
            targetId: event.target.id
        });
        this.setState({
            suggestionsCalls: this.getcallSuggestions(newValue)
        });
        //this.getVoyageSuggestions(newValue);
    };
    renderSuggestionvoyagevalue(suggestion) {
        return <span>{suggestion}</span>;
    }

    getSuggestionvoyageValue(suggestion) {
        return suggestion;
    }
    renderSuggestioncallvalue(suggestion) {
        return <span>{suggestion}</span>;
    }

    getSuggestioncallValue(suggestion) {
        return suggestion;
    }
    //WI-26881:End
    static onSetPreviousState() {
        if (self != null && self != undefined) {
            var filters = self.state.Filters;//self.props.previousState;//RCNG-97
            if (filters.SelectedGeofence == null)
                filters.SelectedGeofence = "";
            self.setState({
                Filters: filters
            });
        }
    }

    ReeferIdschange(event: React.FormEvent<HTMLTextAreaElement>) {
        var filters = this.state.Filters;
        $('#txtReeferId').addClass("fw-semibold");
        var commaValue: string = this.GetMultiLineCsv(event.currentTarget.value);
        filters.SelectedReefer = commaValue;
        this.setState({
            Filters: filters
        });
    }

    BookingNumberchange(event: React.FormEvent<HTMLTextAreaElement>) {
        var filters = this.state.Filters;
        $('#txtBooking').addClass("fw-semibold");
        var commaValue: string = this.GetMultiLineCsv(event.currentTarget.value);
        filters.SelectedBookingNumber = commaValue;
        this.setState({
            Filters: filters
        });
    }

    GetMultiLineCsv(value) {
        //while (value.Contains(Environment.NewLine) || value.Contains('\r') || value.Contains('\n'))--->environment new line pending
        while (value.includes('\r') || value.includes('\n') || value.includes(';') || value.includes(' ')) {
            //while (value.includes('\r') || value.includes('\n') || value.includes(';')) {
            //value = value.Replace(Environment.NewLine, ",");
            value = value.replace('\r'.toString(), ",");
            value = value.replace('\n'.toString(), ",");
            value = value.replace(';'.toString(), ",");
            value = value.replace(' '.toString(), ",");
        }
        while (value.includes(",,")) {
            value = value.replace(",,", ",");
        }
        //s = s.Replace(",", "," + Environment.NewLine);
        return value;
    }

    Oemchange(event: React.FormEvent<HTMLSelectElement>) {
        var filters = this.state.Filters;
        var Value: string = event.currentTarget.value;
        $('#selectOemType').removeClass('fw-semibold');

        if (Value == "OEM Type") {
            filters.SelectedOem = "";
        }
        else {
            if ($('#selectOemType').hasClass('fw-semibold') == false)
                $('#selectOemType').addClass('fw-semibold');
            filters.SelectedOem = Value;
        }

        this.setState({
            Filters: filters
        });
    }

    Countrychange(event: React.FormEvent<HTMLSelectElement>) {
        var filters = this.state.Filters;
        var Value: string = event.currentTarget.value;
        $('#selectRefCountry').removeClass('fw-semibold');

        if (Value == "Country") {
            filters.SelectedCountry = "";
        }
        else {
            if ($('#selectRefCountry').hasClass('fw-semibold') == false)
                $('#selectRefCountry').addClass('fw-semibold');
            filters.SelectedCountry = Value;
        }

        this.setState({
            Filters: filters
        });
    }

    ReportingIntervalchange(event: React.FormEvent<HTMLSelectElement>) {
        var filters = this.state.Filters;
        var Value: string = event.currentTarget.value;
        $('#selectReportingInterval').removeClass('fw-semibold');

        if (Value == "Reporting (min)") {
            filters.SelectedInterval = "";
        }
        else {
            filters.SelectedInterval = Value;
            if ($('#selectReportingInterval').hasClass('fw-semibold') == false)
                $('#selectReportingInterval').addClass('fw-semibold');
        }

        this.setState({
            Filters: filters
        });
    }

    ClearFilter(isFromMicroAlarmChart: boolean) {
        var filters = this.state.Filters;
        filters.SelectedAssetTypes = "";
        filters.SelectedAssetStates = JSON.parse(sessionStorage.getItem('customerDetails')).InventoryState;//RCNG-59//RCNG-70
        filters.SelectedCountry = "";
        filters.SelectedGeofence = "";
        filters.SelectedGeofenceInside = "";
        filters.SelectedInterval = "";
        filters.SelectedOem = "";
        filters.SelectedReefer = "";
        filters.SelectedVesselCode = "";
        filters.SelectedBookingNumber = "";
        //RCNG-3571-as this need to carry fwd
        if (!isFromMicroAlarmChart)
            filters.SelectedCargoCareProfiles = "";//RCNG-3392
        filters.SelectedVesselCD = "";//WI-26881
        filters.SelectedVoyage = "";//WI-26881
        filters.SelectedCall = "";//WI-26881        
        filters.StatusFilters = [];
        customAttributesInfo = {};
        filters.CustomAttributeFilters = customAttributesInfo;
        selectedCustomAttributes = {};
        modelYear = "";
        filters.SelectedPol = "";
        filters.SelectedPod = "";
        $('#txtReeferId').removeClass('fw-semibold');
        $('#txtBooking').removeClass('fw-semibold');
        $('#selectInsideGeofence').removeClass('fw-semibold');
        $('#txtGeofence').removeClass('fw-semibold');
        $('#selectOemType').removeClass('fw-semibold');
        $('#selectRefCountry').removeClass('fw-semibold');
        $('#selectReportingInterval').removeClass('fw-semibold');
        $('#txtVesselCode').removeClass('fw-semibold');

        if (this.state.CustomAttributes != null && this.state.CustomAttributes != undefined && this.state.CustomAttributes.length > 0) {
            $.each(this.state.CustomAttributes, function (i, val) {
                if (val.AttributeTypeCD.trim() == 'E') {
                    var inputControlName = val.AttributeName.replace(' ', '');
                    $('#select' + inputControlName).val(val.AttributeName);
                    $('#select' + inputControlName).removeClass("fw-semibold");
                }
                else if (val.AttributeTypeCD.trim() == 'A' || val.AttributeTypeCD.trim() == 'N') {
                    var inputControlName = val.AttributeName.replace(' ', '');
                    $('#txt' + inputControlName).val('');
                    $('#txt' + inputControlName).removeClass("fw-semibold");
                }
            });
        }
        var defaultOperator = "=";
        $("#MathOption").val(defaultOperator);
        DefaultCheckBoxState = false;
        this.setState({
            SearchName: '',
            IsDefaultSearch: DefaultCheckBoxState,
            SelectedSearch: 'Saved Searches'
        });
        SelectedUserPreferenceId = 0;
        this.setState({
            Filters: filters
        });
        $("#ddlSavedSearch").show();
        $("#txtSearchName").hide();
        $('#InventoryState .Select-control').removeClass("MandatoryBorder");//RCNG-92
        sessionStorage.setItem('DefaultSearch', 'disabled');
        //IsDefaultCheckboxClicked = true;
    }
    ValidateNumaricValue(param) {
        const IsMatch = /^[0-9]*$/;
        if (IsMatch.test(param))
            return true;
        else
            return false;
    }

    static ClearReeferSearchFilters(isFromMicroAlarmChart: boolean) {
        if (self != undefined) {
            self.ClearFilter(isFromMicroAlarmChart);
        }
    }

    onDefaultCheck(event: React.FormEvent<HTMLInputElement>) {
        DefaultCheckBoxState = event.currentTarget.checked;
        //IsDefaultCheckboxClicked = true;
        this.setState({ IsDefaultSearch: DefaultCheckBoxState });
        this.onChangeDefaultSearch();
    }

    onChangeDefaultSearch() {
        if (IsFromLoadState) {
            IsTriggered = false;
            RCNGWindow.ConfirmWindow.showConfirmBox("Would you like to change the search named <i>" + this.state.SelectedSearch + "</i> to a non-default search?", this.SaveUserSearchConfirm.bind(this), this.onCancelSaveDefaultSearch.bind(this));
        }
    }

    ApplyFilter() {
        if (this.state.SelectedSearch == "New") {
            if (this.state.AssetTypes.indexOf("Reefer") > -1 && (this.state.Filters.SelectedAssetStates == "" || this.state.Filters.SelectedAssetStates == null)) {//RCNG-92,RCNG-112
                PopupWindow.showErrorMessage('Error', "Please select Inventory State.");//RCNG-92          
                return;
            }
            var searchName = this.state.SearchName;
            if (searchName.trim().length === 0) {
                PopupWindow.showErrorMessage("Search", "Please enter a valid search name.");
                return;
            }
            if (searchName == null || searchName == '') {
                PopupWindow.showErrorMessage("Search", "Please enter a valid search name.");
                return;
            }
            else {
                if (DefaultCheckBoxState) {
                    IsTriggered = false;
                    RCNGWindow.ConfirmWindow.showConfirmBox("Save the search named <i>" + this.state.SearchName + "</i> as the default search?", this.SaveUserSearchConfirm.bind(this), this.onCancelSaveSearch.bind(this));
                }
                else {
                    IsTriggered = false;
                    RCNGWindow.ConfirmWindow.showConfirmBox("Save the search named <i>" + this.state.SearchName + "</i>?", this.SaveUserSearchConfirm.bind(this), this.onCancelSaveSearch.bind(this));
                    //this.SaveUserSearch();
                }
            }
        }
        else {
            if (this.state.AssetTypes.indexOf("Reefer") > -1 && (this.state.Filters.SelectedAssetStates == "" || this.state.Filters.SelectedAssetStates == null)) {//RCNG-92,RCNG-112
                PopupWindow.showErrorMessage('Error', "Please select Inventory State.");//RCNG-92           
                return;
            }
            var filterChanged = this.CompareExistSearchParams();
            if (!filterChanged) {
                var searchName = this.state.SelectedSearch;
                if (DefaultCheckBoxState) {
                    IsTriggered = false;
                    RCNGWindow.ConfirmWindow.showConfirmBox("Update the search named <i>" + searchName + "</i> as the default search?", this.SaveUserSearchConfirm.bind(this), this.onCancelSaveSearch.bind(this));
                }
                else {
                    IsTriggered = false;
                    RCNGWindow.ConfirmWindow.showConfirmBox("Update the search named <i>" + searchName + "</i> ?", this.SaveUserSearchConfirm.bind(this), this.onCancelSaveSearch.bind(this));
                }
            }
            else
                this.performSearchOperation();
        }
    }

    CompareExistSearchParams() {

        var isModified = true;
        if (SelectedUserPreferenceId != 0 && selectedSearchParams != undefined && selectedSearchParams != null) {
            var userPreference = selectedSearchParams;
            var filters = this.state.Filters;
            if (userPreference.SelectedGeofence == null || userPreference.SelectedGeofence == undefined)
                userPreference.SelectedGeofence = "";
            if (userPreference.SelectedAssetTypes == null || userPreference.SelectedAssetTypes == undefined)
                userPreference.SelectedAssetTypes = "";
            if (userPreference.SelectedAssetStates == null || userPreference.SelectedAssetStates == undefined)
                userPreference.SelectedAssetStates = JSON.parse(sessionStorage.getItem('customerDetails')).InventoryState;///RCNG-70;//RCNG-59
            //if (filters.AllReefers != userPreference.AllReefers)
            //    isModified = false;
            if (filters.SelectedCountry != userPreference.SelectedCountry)
                isModified = false;
            if (filters.SelectedGeofence != userPreference.SelectedGeofence)
                isModified = false;
            //WI-26881:Start
            if (filters.SelectedVesselCD != userPreference.SelectedVesselCD)
                isModified = false;
            if (filters.SelectedVoyage != userPreference.SelectedVoyage)
                isModified = false;
            if (filters.SelectedCall != userPreference.SelectedCall)
                isModified = false;
            //WI-26881:End
            if (filters.SelectedGeofenceInside != userPreference.SelectedGeofenceInside)
                isModified = false;
            if (filters.SelectedInterval != userPreference.SelectedInterval)
                isModified = false;
            if (filters.SelectedAssetTypes != userPreference.SelectedAssetTypes)
                isModified = false;
            if (filters.SelectedAssetStates != userPreference.SelectedAssetStates)
                isModified = false;
            if (filters.SelectedOem != userPreference.SelectedOem)
                isModified = false;
            if (filters.SelectedReefer != userPreference.SelectedReefer)
                isModified = false;
            if (filters.SelectedVesselCode != userPreference.SelectedVesselCode)
                isModified = false;
            if (filters.SelectedBookingNumber != userPreference.SelectedBookingNumber)
                isModified = false;
            if (customAttributesInfo == null || customAttributesInfo == undefined)
                customAttributesInfo = {};

            if (selectedCustomAttributes == null || selectedCustomAttributes == undefined)
                selectedCustomAttributes = {};

            if (this.getCustomAttributesDiff(customAttributesInfo, selectedCustomAttributes).length > 0)
                isModified = false;
            //if (this.state.IsDefaultSearch != defaultSearch)
            //    isModified = false;
            //if (IsDefaultCheckboxClicked)
            //    isModified = false;
            if (DefaultCheckBoxState != IsFromLoadState)
                isModified = false;
            //if (!IsFromLoadState)
            //    isModified = false;
            //RCNG-5880
            if (filters.SelectedPol != userPreference.SelectedPol)
                isModified = false;

            if (filters.SelectedPod != userPreference.SelectedPod)
                isModified = false;

            if (filters.SelectedCargoCareProfiles != userPreference.SelectedCargoCareProfiles)
                isModified = false;

        }
        return isModified;

    }

    getCustomAttributesDiff(obj1, obj2) {
        const diff = Object.keys(obj1).reduce((result, key) => {
            if (!obj2.hasOwnProperty(key)) {
                result.push(key);
            } else if (isEqual(obj1[key], obj2[key])) {
                const resultKeyIndex = result.indexOf(key);
                result.splice(resultKeyIndex, 1);
            }
            return result;
        }, Object.keys(obj2));

        return diff;
    }

    loadDefaultSavedSearch() {
        this.ResetAssetsData();
        setTimeout(() => { this.LoadGetAllAssetTypeData() }, 5000);
    }

    performSearchOperation() {
        var filters = this.state.Filters;
        var allSearchControls = this.GetSearchControls().map(i => i.value);
        var selectedSearchControls = this.state.SelectedSearchControls;
        var modefiedSearchControls = allSearchControls.filter(item => selectedSearchControls.indexOf(item) < 0);
        if (modefiedSearchControls != null && modefiedSearchControls.length > 0) {
            modefiedSearchControls.map(field => {
                switch (field) {
                    case "BookingNumber":
                        filters.SelectedBookingNumber = "";
                        return;
                    case "CargoCareProfile":
                        filters.SelectedCargoCareProfiles = "";
                        return;
                    case "GeofenceStatus":
                        filters.SelectedGeofenceInside = "";
                        return;
                    case "GeofenceID":
                        filters.SelectedGeofence = "";
                        return;
                    case "AssetTypes":
                        filters.SelectedAssetTypes = "";
                        return;
                    case "InventoryState":
                        filters.SelectedAssetStates = JSON.parse(sessionStorage.getItem('customerDetails')).InventoryState;
                        return;
                    case "OEM":
                        filters.SelectedOem = "";
                        return;
                    case "Countries":
                        filters.SelectedCountry = "";
                        return;
                    case "ReportingInterval":
                        filters.SelectedInterval = "";
                        return;
                    case "VesselID":
                        filters.SelectedVesselCode = "";
                        return;
                    case "Voyage":
                        filters.SelectedVoyage = "";
                        return;
                    case "Call":
                        filters.SelectedCall = "";
                        return;
                    case "SaveSearch":
                        DefaultCheckBoxState = false;
                        this.setState({
                            SearchName: '',
                            IsDefaultSearch: DefaultCheckBoxState,
                            SelectedSearch: 'Saved Searches'
                        });
                        return;
                    //RCNG5588
                    case "POL":
                        filters.SelectedPol = "";
                        return;
                    case "POD":
                        filters.SelectedPod = "";
                        return;

                }
            });
        }

        $('#globalLoader').show();
        this.ResetAssetsData();

        this.setState({ Filters: filters }, () => {
            
            let selectedCCP = [];
            if (Array.isArray(self.state.Filters.SelectedCargoCareProfiles)) {
                selectedCCP = self.state.Filters.SelectedCargoCareProfiles.filter(i => i);
            } else if (typeof self.state.Filters.SelectedCargoCareProfiles === 'string') {
                selectedCCP = self.state.Filters.SelectedCargoCareProfiles.split(",").filter(i => i);
            } else if (self.state.Filters.SelectedCargoCareProfiles) {
                selectedCCP = [self.state.Filters.SelectedCargoCareProfiles];
            }
            //selectedCCP = self.state.Filters.SelectedCargoCareProfiles.split(",").filter(i => i);

            var selectedCCPCodes = "";

            if (selectedCCP.length > 0) {
                for (const CCP of selectedCCP) {
                    selectedCCPCodes += self.state.CargoCareProfiles.find(x => x.CargoCareCustomerProfileID === parseInt(CCP)).CargoCareCustomerProfileCode + ", ";
                }
            }

            if (selectedCCPCodes != "") {
                selectedCCPCodes = selectedCCPCodes.slice(0, -2);
            }

            this.props.SendSearchLoadingIsInProgressToHome(true,selectedCCPCodes);
            this.LoadGetAllAssetTypeData();//WI-23763});
        });
    }

    ResetAssetsData() {
        ReeferCallout.ResetMapPushpins();
        ReeferCallout.ResetAllPushpins();
        this.props.clearHistoryGridHeaders();
        var assetTypes = this.state.AssetTypes;
        $.each(assetTypes, function (index, value) {
            if (value == "Reefer") {
                ReeferStatusGrid.ClearReeferStatusGridData();
                ReeferHistoryGrid.ClearHistoryGridData();
            }
            if (value == "Genset") {
                GensetStatusGrid.ClearGensetStatusGridData();
                GensetHistoryGrid.ClearHistoryGridData();

            }
            if (value == "Dry") {
                DryStatusSSRMGrid.ClearDryStatusGridData();
                DryHistoryGrid.ClearHistoryGridData();
            }
            if (value == "Chassis") {
                ChassisStatusGrid.ClearChassisStatusGridData();
                ChassisHistoryGrid.ClearHistoryGridData();
            }
        });

    }

    GetSearchControls = () => {
        let options = [];
        var cargoCareProfileRight = UserRights.checkMenuItemVisibility('247')[0];
        var offerSelectControls = AssetSearch;

        forIn(AssetSearch, function (value, key) {
            if (((cargoCareProfileRight == "hidden") && key == "CargoCareProfile")
                || (!hasReefers && key == "BookingNumber")
                || (assetCount == 1 && key == "AssetTypes")
                || (!showOem && key == "OEM")
                || (!showInvState && key == "InventoryState")
            ) {
                // dont push 
            }
            else {
                options.push({ desc: value, value: key })
            }
        });

        return options;
    };

    static RestoreAdvanceSearchControls() {
        if(self != undefined)
            setTimeout(() => { self.GetSelectedSearchControls() }, 500);
    }

    GetSelectedSearchControls() {
        var url = Config.ApiBaseUrl + '/api/User/GetUserSearchControlsPreference?dashboardPreferenceId='+this.props.dashboardPreferenceId;
        var request = RCUtils.FetchRequest(url, { method: 'GET', headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
        fetch(request)
            .then(RCUtils.handleError)
            .then(response => response.json())
            .then(data => {
                if (data == "") {
                    this.setState({ SelectedSearchControls: this.GetSearchControls().map(i => i.value) });
                }
                else {
                    if (UserRights.checkMenuItemVisibility('247')[0] == "hidden") {
                        const index = data.indexOf('CargoCareProfile');
                        if (index > -1) {
                            data.splice(index, 1);
                        }
                    }
                    this.setState({ SelectedSearchControls: data });

                }
            });
    }

    static getSearchPreferenceData() {
        var searchName = "";
        var userPrefId = 0;
        if (SelectedUserPreferenceId == 0) {
            userPrefId = 0;
            searchName = self.state.SearchName;
        }
        else {
            userPrefId = SelectedUserPreferenceId;
            searchName = self.state.SelectedSearch;
        }
        var data = self.state.Filters;

        if (self.state.CustomAttributes != null && self.state.CustomAttributes != undefined && self.state.CustomAttributes.length > 0) {
            if (customAttributesInfo != null && customAttributesInfo != undefined && customAttributesInfo != {}) {
                data.CustomAttributeFilters = customAttributesInfo;
            }
        }
        var searchPreferences: any = {
            PreferenceData: JSON.stringify(data),
            SearchName: searchName,
            IsDefaultSearch: DefaultCheckBoxState//this.state.IsDefaultSearch
        };

        return searchPreferences;
    }

    SaveUserSearchConfirm() {
        if (!IsTriggered) {
            IsTriggered = true;
            RCNGWindow.ConfirmWindow.close();
            var searchName = "";
            var userPrefId = 0;
            if (SelectedUserPreferenceId == 0) {
                userPrefId = 0;
                searchName = this.state.SearchName;
            }
            else {
                userPrefId = SelectedUserPreferenceId;
                searchName = this.state.SelectedSearch;
            }
            var url = Config.ApiBaseUrl + '/api/User/SaveUserSearchPreference';
            //  var data = { Defaultlayouts: this.state.Defaultlayouts, DashBoardItems: this.state.DashBoardItems, layouts: this.state.layouts, WGSwitchAll: this.state.WGSwitchAll }
            //var data = { AssetNumber: this.state.Filters.AssetNumber, AssetType: this.state.Filters.AssetType, City: this.state.Filters.City, Country: this.state.Filters.Country, CustomerID: this.state.Filters.CustomerID, CustomerTypeCode: this.state.Filters.CustomerTypeCode, DeviceFence: this.state.Filters.DeviceFence, Geofence: this.state.Filters.Geofence, GeofenceInside: this.state.Filters.GeofenceInside, Oem: this.state.Filters.Oem, POI: this.state.Filters.POI, Region: this.state.Filters.Region, ReportingInterval: this.state.Filters.ReportingInterval, ServerFence: this.state.Filters.ServerFence, State: this.state.Filters.State, ZipCode: this.state.Filters.ZipCode };
            var data = this.state.Filters;

            if (this.state.CustomAttributes != null && this.state.CustomAttributes != undefined && this.state.CustomAttributes.length > 0) {
                if (customAttributesInfo != null && customAttributesInfo != undefined && customAttributesInfo != {}) {
                    data.CustomAttributeFilters = customAttributesInfo;
                }
            }
            var dashboardPreferenceId: any = this.props.dashboardPreferenceId;
            var revisionNum: any = this.props.revisionNum; 
            var preferencedata = {
                UserPreferenceId: userPrefId, UserId: 0, FunctionId: 1, PreferenceType: 'S', PreferenceData: JSON.stringify(data), SearchName: searchName,
                IsDefaultSearch: DefaultCheckBoxState, DashboardPreferenceId: dashboardPreferenceId, RevisionNum: revisionNum//this.state.IsDefaultSearch
            };
            var request = RCUtils.FetchRequest(url, { method: 'POST', body: JSON.stringify(preferencedata), headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
            fetch(request)
                .then(RCUtils.handleError)
                .then(response => response.json())
                .then(data => {
                    if(data == "RevisionNum Invalid")
                        this.props.validateRevisionNum(dashboardPreferenceId);
                    else if (data == "SearchName Already Exist") {
                        PopupWindow.showErrorMessage("Search", "Search name already exist.");
                    }
                    else {                        
                        if (data == "Record Saved") {
                            var msg = "Search saved successfully.";
                            this.ReloadPreferenceData(msg, searchName);
                            this.setState({ IsDefaultSearch: DefaultCheckBoxState });
                        }
                        else if (data == "Record Updated") {
                            var msg = "Search updated successfully.";
                            this.ReloadPreferenceData(msg, searchName);
                            this.FillFilters(userPrefId);
                            this.setState({ IsDefaultSearch: DefaultCheckBoxState });
                        }
                        this.props.refreshRevisionNum(dashboardPreferenceId, false);
                    }
                });



        }
    }

    RefreshDefaultSearchData(){
        var functionID = 1;
        var url = Config.ApiBaseUrl + '/api/User/GetDefaultSearchParams?FunctionId=' + functionID;
        var request = RCUtils.FetchRequest(url);
        RCUtils.fetchRetry(request)
            .then(RCUtils.handleResponse)
            .then(response => response.json() as Promise<any>)
            .then(data => {
                if (data != null && data != undefined) {
                    this.setState({ DefaultSearchData : data });                                               
                }
            });
    }

    ReloadPreferenceData(message: any, searchName: any) {
        this.LoadUserPreferenceSearchNames(searchName);
        this.RefreshDefaultSearchData();
        this.performSearchOperation();
        this.setState({ SelectedSearch: searchName });
        $("#ddlSavedSearch").show();
        $("#txtSearchName").hide();
        PopupWindow.showErrorMessage("Search", message);
    }

    SaveUserSearch() {
        var userPrefId = 0;
        RCNGWindow.ConfirmWindow.close();
        var url = Config.ApiBaseUrl + '/api/User/SaveUserSearchPreference';
        //  var data = { Defaultlayouts: this.state.Defaultlayouts, DashBoardItems: this.state.DashBoardItems, layouts: this.state.layouts, WGSwitchAll: this.state.WGSwitchAll }
        //var data = { AssetNumber: this.state.Filters.AssetNumber, AssetType: this.state.Filters.AssetType, City: this.state.Filters.City, Country: this.state.Filters.Country, CustomerID: this.state.Filters.CustomerID, CustomerTypeCode: this.state.Filters.CustomerTypeCode, DeviceFence: this.state.Filters.DeviceFence, Geofence: this.state.Filters.Geofence, GeofenceInside: this.state.Filters.GeofenceInside, Oem: this.state.Filters.Oem, POI: this.state.Filters.POI, Region: this.state.Filters.Region, ReportingInterval: this.state.Filters.ReportingInterval, ServerFence: this.state.Filters.ServerFence, State: this.state.Filters.State, ZipCode: this.state.Filters.ZipCode };
        var data = this.state.Filters;
        var preferencedata = {
            UserPreferenceId: userPrefId, UserId: 0, FunctionId: 1, PreferenceType: 'S', PreferenceData: JSON.stringify(data), SearchName: this.state.SearchName,
            IsDefaultSearch: DefaultCheckBoxState//this.state.IsDefaultSearch
        };
        var request = RCUtils.FetchRequest(url, { method: 'POST', body: JSON.stringify(preferencedata), headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
        fetch(request)
            .then(RCUtils.handleError)
            .then(response => response.json())
            .then(data => {
                if (data == "Record Saved" || data == "Record Updated") {
                    var msg = "Search saved successfully.";
                    this.ReloadPreferenceData(msg, this.state.SearchName);

                } else if (data == "SearchName Already Exist") {
                    PopupWindow.showErrorMessage("Search", "Search name already exist.");
                }
            });

        this.setState({ IsDefaultSearch: DefaultCheckBoxState });
    }

    GetDataForNewlySavedUserPreference(searchName: string) {

        let objNewlySavedUserPreference = this.state.SearchNamesList.find(x => x.SearchName === searchName);

        if (objNewlySavedUserPreference != null && objNewlySavedUserPreference != undefined) {

            SelectedUserPreferenceId = objNewlySavedUserPreference.UserPreferenceId;

            if (SelectedUserPreferenceId != null && SelectedUserPreferenceId > 0)
                this.FillFilters(SelectedUserPreferenceId);
        }
    }

    SearchNameOnchange(event: React.FormEvent<HTMLInputElement>) {
        var Value: string = event.currentTarget.value;
        this.setState({
            SearchName: Value
        });
    }

    IsDefaultSearchChange = (event: React.FormEvent<HTMLInputElement>) => {
        defaultSearch = event.currentTarget.checked;
        this.setState({
            IsDefaultSearch: !this.state.IsDefaultSearch,
        });
    }

    AssetChange(value) {
        var filters = this.state.Filters;
        filters.SelectedAssetTypes = value;

        this.setState({ Filters: filters });
    }

    CargoCareProfileChange(value) {
        var filters = this.state.Filters;
        filters.SelectedCargoCareProfiles = value;
        this.setState({ Filters: filters });
    }
    //RCNG5588
    PolChange(value) {
        var filters = this.state.Filters;
        filters.SelectedPol = value;
        this.setState({ Filters: filters });
    }
    PodChange(value) {
        var filters = this.state.Filters;
        filters.SelectedPod = value;
        this.setState({ Filters: filters });
    }

    AssetStateChange(value) {
        var filters = this.state.Filters;
        filters.SelectedAssetStates = value;
        if (value == "")
            $('#InventoryState .Select-control').addClass("MandatoryBorder");
        else
            $('#InventoryState .Select-control').removeClass("MandatoryBorder");
        this.setState({ Filters: filters });
    }
    FillFilters(preferenceId: any) {
        if (preferenceId != "") {
            var url = Config.ApiBaseUrl + '/api/User/GetSearchParamsByPreferenceID?UserPreferenceId=' + preferenceId;
            //SelectedUserPreferenceId = preferenceId;
            var request = RCUtils.FetchRequest(url, { method: 'POST', headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
            fetch(request)
                .then(RCUtils.handleError)
                .then(response => response.json() as Promise<server.UserPreferenceData>)
                .then(data => {
                    var UserPreference = JSON.parse(data.PreferenceData);
                    selectedSearchParams = UserPreference;
                    var filters = this.state.Filters;
                    filters.AllReefers = UserPreference.AllReefers;
                    filters.SelectedCountry = UserPreference.SelectedCountry;
                    if (UserPreference.SelectedGeofence != null && UserPreference.SelectedGeofence != undefined)
                        filters.SelectedGeofence = UserPreference.SelectedGeofence;
                    else
                        filters.SelectedGeofence = "";
                    filters.SelectedGeofenceInside = UserPreference.SelectedGeofenceInside;
                    filters.SelectedInterval = UserPreference.SelectedInterval;
                    if (UserPreference.SelectedAssetTypes != null && UserPreference.SelectedAssetTypes != undefined)
                        filters.SelectedAssetTypes = UserPreference.SelectedAssetTypes;
                    else
                        filters.SelectedAssetTypes = "";
                    if (UserPreference.SelectedAssetStates != null && UserPreference.SelectedAssetStates != undefined)
                        filters.SelectedAssetStates = UserPreference.SelectedAssetStates;
                    else
                        filters.SelectedAssetStates = JSON.parse(sessionStorage.getItem('customerDetails')).InventoryState;///RCNG-70;//RCNG-59
                    filters.SelectedOem = UserPreference.SelectedOem;
                    filters.SelectedReefer = UserPreference.SelectedReefer;
                    filters.SelectedVesselCode = UserPreference.SelectedVesselCode;
                    filters.SelectedBookingNumber = UserPreference.SelectedBookingNumber;
                    filters.SelectedCargoCareProfiles = UserPreference.SelectedCargoCareProfiles;//RCNG-3392
                    filters.SelectedPol = UserPreference.SelectedPol; 
                    filters.SelectedPod = UserPreference.SelectedPod; 

                    // Start WI-268881
                    if (UserPreference.SelectedVesselCD != null && UserPreference.SelectedVesselCD != undefined)
                        filters.SelectedVesselCD = UserPreference.SelectedVesselCD;
                    else
                        filters.SelectedVesselCD = "";
                    if (UserPreference.SelectedVoyage != null && UserPreference.SelectedVoyage != undefined)
                        filters.SelectedVoyage = UserPreference.SelectedVoyage;
                    else
                        filters.SelectedVoyage = "";
                    if (UserPreference.SelectedCall != null && UserPreference.SelectedCall != undefined)
                        filters.SelectedCall = UserPreference.SelectedCall;
                    else
                        filters.SelectedCall = "";
                    // End WI-26881
                    filters.StatusFilters = UserPreference.StatusFilters;
                    customAttributesInfo = UserPreference.CustomAttributeFilters;
                    selectedCustomAttributes = cloneDeep(customAttributesInfo);
                    this.setState({ Filters: filters });
                    //$('#globalLoader').hide();
                    DefaultCheckBoxState = data.DefaultSearch;
                    IsFromLoadState = data.DefaultSearch;
                    this.BindCustomAttributesValues();
                });
        }
    }

    ClearCustomAttributesData() {
        if (this.state.CustomAttributes != null && this.state.CustomAttributes != undefined && this.state.CustomAttributes.length > 0) {
            $.each(this.state.CustomAttributes, function (i, val) {
                if (val.AttributeTypeCD.trim() == 'E') {
                    var inputControlName = val.AttributeName.replace(' ', '');
                    $('#select' + inputControlName).val(val.AttributeName);
                    $('#select' + inputControlName).removeClass("fw-semibold");
                }
                else if (val.AttributeTypeCD.trim() == 'A' || val.AttributeTypeCD.trim() == 'N') {
                    var inputControlName = val.AttributeName.replace(' ', '');
                    $('#txt' + inputControlName).val('');
                    $('#txt' + inputControlName).removeClass("fw-semibold");
                }
            });
        }
        modelYear = "";
        var defaultOperator = "=";
        $("#MathOption").val(defaultOperator);
    }

    BindCustomAttributesValues() {
        if (this.state.CustomAttributes != null && this.state.CustomAttributes != undefined && this.state.CustomAttributes.length > 0) {
            var customAttributes: any = this.state.CustomAttributes;
            this.ClearCustomAttributesData();
            if (customAttributesInfo != null && customAttributesInfo != undefined && customAttributesInfo != {}) {
                var selectedCustomAttributesInfo = Object.keys(customAttributesInfo).map((key) => [key, customAttributesInfo[key]]);
                $.each(selectedCustomAttributesInfo, function (index, value) {
                    var selectedParam = value[0];
                    var selectedValue = value[1];

                    var attributeType = customAttributes.filter(x => x.AttributeName.replace(" ", "") == selectedParam);
                    if (attributeType[0] != null && attributeType[0] != '') {
                        if (attributeType[0].AttributeTypeCD == 'E') {
                            $("#select" + selectedParam).val(selectedValue);
                            if ($('#select' + selectedParam).hasClass('fw-semibold') == false)
                                $('#select' + selectedParam).addClass("fw-semibold");
                        }
                        else if (attributeType[0].AttributeTypeCD == 'A') {
                            $("#txt" + selectedParam).val(selectedValue);
                            if ($('#txt' + selectedParam).hasClass('fw-semibold') == false)
                                $('#txt' + selectedParam).addClass("fw-semibold");
                        }
                        else if (attributeType[0].AttributeTypeCD == 'N') {
                            var operatorType = selectedValue.split("&")[0];
                            var operatorValue = selectedValue.split("&")[2];
                            $("#MathOption").val(operatorType);
                            $("#txt" + selectedParam).val(operatorValue);
                            modelYear = operatorValue;
                            if ($('#txt' + selectedParam).hasClass('fw-semibold') == false)
                                $('#txt' + selectedParam).addClass("fw-semibold");
                        }
                    }
                });
            }
        }
    }

    LoadReeferGrids() {
        var AlertMessage = "";
        if (!(!modelYear || modelYear == undefined || modelYear == "" || modelYear.length == 0)) {
            //if ((modelYear.length > 0) || self.ValidateNumaricValue(modelYear)) {
            if ((self.ValidateNumaricValue(modelYear)) === true) {
                if ((modelYear < modelYearMin) || (modelYear > modelYearMax)) {
                    AlertMessage = "This value must be a number greater than or equal to " + modelYearMin + " and less than or equal to " + modelYearMax + ".\n";
                }
            }
        }
        if (AlertMessage == '') {
            this.props.reeferIdForHeader('');
            this.state.Filters.AllReefers = "";
            this.state.Filters.StatusFilters = [];

            if (this.state.CustomAttributes != null && this.state.CustomAttributes != undefined && this.state.CustomAttributes.length > 0) {
                if (customAttributesInfo != null && customAttributesInfo != undefined && customAttributesInfo != {}) {
                    this.state.Filters.CustomAttributeFilters = customAttributesInfo;
                }
            }

            if (this.state.Filters.SelectedCountry != "" || this.state.Filters.SelectedGeofence != "" || this.state.Filters.SelectedGeofenceInside != ""
                || this.state.Filters.SelectedInterval != "" || this.state.Filters.SelectedOem != "" || this.state.Filters.SelectedReefer != ""
                || this.state.Filters.SelectedVesselCode != "" || this.state.Filters.SelectedBookingNumber != "" || this.state.Filters.SelectedVesselCD != "" || this.state.Filters.SelectedVoyage != "" || this.state.Filters.SelectedCall != "") {//WI-26881
                //this.props.bindingReeferStatusGrid(this.state.Filters);//WI-23763
            }
            else {
                this.state.Filters.StatusFilters = [];
                this.state.Filters.AllReefers = "All Assets";
                //this.props.bindingReeferStatusGrid(this.state.Filters);//WI-23763
            }
        }
        else {
            PopupWindow.showErrorMessage('Error', AlertMessage);
        }
    }
    LoadGensetGrids() {
        var AlertMessage = "";
        if (!(!modelYear || modelYear == undefined || modelYear == "" || modelYear.length == 0)) {
            //if ((modelYear.length > 0) || self.ValidateNumaricValue(modelYear)) {
            if ((self.ValidateNumaricValue(modelYear)) === true) {
                if ((modelYear < modelYearMin) || (modelYear > modelYearMax)) {
                    AlertMessage = "This value must be a number greater than or equal to " + modelYearMin + " and less than or equal to " + modelYearMax + ".\n";
                }
            }
        }
        if (AlertMessage == '') {
            this.props.reeferIdForHeader('');
            this.state.Filters.AllReefers = "";
            this.state.Filters.StatusFilters = [];

            if (this.state.CustomAttributes != null && this.state.CustomAttributes != undefined && this.state.CustomAttributes.length > 0) {
                if (customAttributesInfo != null && customAttributesInfo != undefined && customAttributesInfo != {}) {
                    this.state.Filters.CustomAttributeFilters = customAttributesInfo;
                }
            }

            if (this.state.Filters.SelectedCountry != "" || this.state.Filters.SelectedGeofence != "" || this.state.Filters.SelectedGeofenceInside != ""
                || this.state.Filters.SelectedInterval != "" || this.state.Filters.SelectedOem != "" || this.state.Filters.SelectedReefer != "" || this.state.Filters.SelectedVesselCode != "" || this.state.Filters.SelectedVesselCD != "" || this.state.Filters.SelectedVoyage != "" || this.state.Filters.SelectedCall != "") {//WI-26881
                //this.props.bindingGensetStatusGrid(this.state.Filters);//WI-23763
            }
            else {
                this.state.Filters.StatusFilters = [];
                this.state.Filters.AllReefers = "All Assets";
                // this.props.bindingGensetStatusGrid(this.state.Filters);//WI-23763
            }

        }
        else {
            PopupWindow.showErrorMessage('Error', AlertMessage);
        }
    }

    LoadDryContainerGrids() {
        var AlertMessage = "";
        if (!(!modelYear || modelYear == undefined || modelYear == "" || modelYear.length == 0)) {
            //if ((modelYear.length > 0) || self.ValidateNumaricValue(modelYear)) {
            if ((self.ValidateNumaricValue(modelYear)) === true) {
                if ((modelYear < modelYearMin) || (modelYear > modelYearMax)) {
                    AlertMessage = "This value must be a number greater than or equal to " + modelYearMin + " and less than or equal to " + modelYearMax + ".\n";
                }
            }
        }
        if (AlertMessage == '') {
            this.props.reeferIdForHeader('');
            this.state.Filters.AllReefers = "";
            this.state.Filters.StatusFilters = [];

            if (this.state.CustomAttributes != null && this.state.CustomAttributes != undefined && this.state.CustomAttributes.length > 0) {
                if (customAttributesInfo != null && customAttributesInfo != undefined && customAttributesInfo != {}) {
                    this.state.Filters.CustomAttributeFilters = customAttributesInfo;
                }
            }

            if (this.state.Filters.SelectedCountry != "" || this.state.Filters.SelectedGeofence != "" || this.state.Filters.SelectedGeofenceInside != ""
                || this.state.Filters.SelectedInterval != "" || this.state.Filters.SelectedOem != "" || this.state.Filters.SelectedReefer != ""
                || this.state.Filters.SelectedVesselCode != "" || this.state.Filters.SelectedVesselCD != "" || this.state.Filters.SelectedVoyage != "" || this.state.Filters.SelectedCall != "") {//WI-26881
                //this.props.bindingDryStatusGrid(this.state.Filters);//WI-23763
            }
            else {
                this.state.Filters.StatusFilters = [];
                this.state.Filters.AllReefers = "All Assets";
                //this.props.bindingDryStatusGrid(this.state.Filters);//WI-23763
            }

        }
        else {
            PopupWindow.showErrorMessage('Error', AlertMessage);
        }
    }

    LoadChassisContainerGrids() {
        var AlertMessage = "";
        if (!(!modelYear || modelYear == undefined || modelYear == "" || modelYear.length == 0)) {
            //if ((modelYear.length > 0) || self.ValidateNumaricValue(modelYear)) {
            if ((self.ValidateNumaricValue(modelYear)) === true) {
                if ((modelYear < modelYearMin) || (modelYear > modelYearMax)) {
                    AlertMessage = "This value must be a number greater than or equal to " + modelYearMin + " and less than or equal to " + modelYearMax + ".\n";
                }
            }
        }
        if (AlertMessage == '') {
            this.props.reeferIdForHeader('');
            this.state.Filters.AllReefers = "";
            this.state.Filters.StatusFilters = [];

            if (this.state.CustomAttributes != null && this.state.CustomAttributes != undefined && this.state.CustomAttributes.length > 0) {
                if (customAttributesInfo != null && customAttributesInfo != undefined && customAttributesInfo != {}) {
                    this.state.Filters.CustomAttributeFilters = customAttributesInfo;
                }
            }

            if (this.state.Filters.SelectedCountry != "" || this.state.Filters.SelectedGeofence != "" || this.state.Filters.SelectedGeofenceInside != ""
                || this.state.Filters.SelectedInterval != "" || this.state.Filters.SelectedOem != "" || this.state.Filters.SelectedReefer != ""
                || this.state.Filters.SelectedVesselCode != "" || this.state.Filters.SelectedVesselCD != "" || this.state.Filters.SelectedVoyage != "" || this.state.Filters.SelectedCall != "") {//WI-26881
                //this.props.bindingChassisStatusGrid(this.state.Filters);//WI-23763
            }
            else {
                this.state.Filters.StatusFilters = [];
                this.state.Filters.AllReefers = "All Assets";
                //this.props.bindingChassisStatusGrid(this.state.Filters);//WI-23763
            }

        }
        else {
            PopupWindow.showErrorMessage('Error', AlertMessage);
        }
    }
    //WI-23763
    LoadGetAllAssetTypeData() {
        var AlertMessage = "";
        if (!(!modelYear || modelYear == undefined || modelYear == "" || modelYear.length == 0)) {
            //if ((modelYear.length > 0) || self.ValidateNumaricValue(modelYear)) {
            if ((self.ValidateNumaricValue(modelYear)) === true) {
                if ((modelYear < modelYearMin) || (modelYear > modelYearMax)) {
                    AlertMessage = "This value must be a number greater than or equal to " + modelYearMin + " and less than or equal to " + modelYearMax + ".\n";
                }
            }
        }
        if ((this.state.AssetTypes.indexOf("Reefer") > -1 || this.state.AssetTypes.indexOf("Genset") > -1) && (this.state.Filters.SelectedAssetStates == "" || this.state.Filters.SelectedAssetStates == null))//RCNG-61
            AlertMessage = "Please select Inventory State.";//RCNG-61

        if (AlertMessage == '') {
            this.props.reeferIdForHeader('');
            //WI-23853
            if (this.props.previousState != null && this.props.previousState != undefined && this.props.previousState.StatusFilters != null && this.props.previousState.StatusFilters.length > 0) {
                this.props.previousState.StatusFilters = [];
            }

            this.state.Filters.AllReefers = "";
            //this.state.Filters.StatusFilters = [];

            if (this.state.CustomAttributes != null && this.state.CustomAttributes != undefined && this.state.CustomAttributes.length > 0) {
                if (customAttributesInfo != null && customAttributesInfo != undefined && customAttributesInfo != {}) {
                    this.state.Filters.CustomAttributeFilters = customAttributesInfo;
                }
            }

            if (this.state.Filters.SelectedCountry != "" || this.state.Filters.SelectedGeofence != "" || this.state.Filters.SelectedGeofenceInside != ""
                || this.state.Filters.SelectedInterval != "" || this.state.Filters.SelectedOem != "" || this.state.Filters.SelectedReefer != ""
                || this.state.Filters.SelectedVesselCode != "" || this.state.Filters.SelectedBookingNumber != "" || this.state.Filters.SelectedVesselCD != "" || this.state.Filters.SelectedVoyage != "" || this.state.Filters.SelectedCall != "") {//WI-26881
                this.props.bindingReeferGensetDryChassisStatusGrid(this.state.Filters, false);
            }
            else {
                //this.state.Filters.StatusFilters = [];
                //this.state.Filters.AllReefers = "All Assets";
                //this.props.bindingReeferGensetDryChassisStatusGrid(this.state.Filters);

                //WI-23853
                this.state.Filters.AllReefers = "All Assets";
                var statusfilters = [];
                var filters = this.state.Filters;
                filters.StatusFilters = statusfilters;
                this.setState({
                    Filters: filters
                });

                this.props.bindingReeferGensetDryChassisStatusGrid(filters, false);
            }

        }
        else {
            PopupWindow.showErrorMessage('Error', AlertMessage);
            $('#globalLoader').hide();
        }

    }
    //WI-23795
    renderSaveSearchDialog() {
        self.props.renderSaveSearchControl();
    }
    showGlobalLoader() {
        $('#globalLoader').show();
    }
    static RefreshSearchControls() {
        var url = Config.ApiBaseUrl + '/api/User/GetUserSearchControlsPreference?dashboardPreferenceId='+self.props.dashboardPreferenceId;
        var request = RCUtils.FetchRequest(url, { method: 'GET', headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
        fetch(request)
            .then(RCUtils.handleError)
            .then(response => response.json())
            .then(data => {
                if (data != null && data != "") {
                    if (UserRights.checkMenuItemVisibility('247')[0] == "hidden") {
                        const index = data.indexOf('CargoCareProfile');
                        if (index > -1) {
                            data.splice(index, 1);
                        }
                    }
                }
                self.setState({ SelectedSearchControls: data });
                $('#globalLoader').hide();
                ($("[data-bs-dismiss=modal]") as any).trigger({ type: "click" });
                return (data != null && data != undefined) ? data.length : '';
            });
    }
    static FindAssetByFenceLocation(fenceId: string) {

        self.ClearFilter(false);
        self.ResetAssetsData();
        self.props.reeferIdForHeader('');
        self.state.Filters.AllReefers = "";
        self.state.Filters.StatusFilters = [];
        self.state.Filters.SelectedGeofence = fenceId;
        //setTimeout(() => { self.showGlobalLoader() }, 1000);
        self.showGlobalLoader();
        self.props.bindingReeferGensetDryChassisStatusGrid(self.state.Filters, true);
    }

    onDeleteConfirmation(preferenceId: any, searchName: any, defaultSearch: any) {
        IsTriggered = false;
        var message = "Delete the search named <i>" + searchName + "</i> ?";
        if (defaultSearch)
            message += " This is currently the default search. Following this action, no default search will be set until another is identified.";
        RCNGWindow.ConfirmWindow.showConfirmBox(message, this.onDeleteSearchName.bind(this, preferenceId), this.onCancelSearchName.bind(this));
    }

    onDeleteSearchName(preferenceId) {
        if (!IsTriggered) {
            IsTriggered = true;
            RCNGWindow.ConfirmWindow.close();
            var url = Config.ApiBaseUrl + '/api/User/DeleteSearchPreference?UserPreferenceId=' + preferenceId;
            var request = RCUtils.FetchRequest(url, { method: 'POST', headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
            fetch(request)
                .then(RCUtils.handleError)
                .then(response => response.json() as Promise<string>)
                .then(data => {
                    if (data != null && data != undefined) {
                        if (data == "Success") {
                            this.LoadUserPreferenceSearchNames(this.state.SearchName);
                            this.ClearFilter(false);
                        }
                        else
                            PopupWindow.showErrorMessage("Error", data);
                    }
                });
        }
    }

    onCancelSearchName() {
        RCNGWindow.ConfirmWindow.close();
    }

    onCancelSaveSearch() {
        RCNGWindow.ConfirmWindow.close();
        this.performSearchOperationOnCancel();
    }

    onCancelSaveDefaultSearch() {
        DefaultCheckBoxState = IsFromLoadState;
        this.setState({ IsDefaultSearch: DefaultCheckBoxState });
        RCNGWindow.ConfirmWindow.close();
        //this.performSearchOperationOnCancel();
    }

    performSearchOperationOnCancel() {
        if (!IsTriggered) {
            IsTriggered = true;
            $('#globalLoader').show();
            this.ResetAssetsData();
            this.LoadGetAllAssetTypeData();
        }
    }

    onCreateNewSavedSearch(param: any, id: any, isDefault: any): void {
        var Value: string = param;
        if (param == "New") {
            self.ClearFilter(false);
            $("#ddlSavedSearch").hide();
            $("#txtSearchName").show();
            this.setState({ SelectedSearch: Value });
            SelectedUserPreferenceId = 0;
        }
        else {
            defaultSearch = false;
            self.ClearFilter(false);
            if (isDefault)
                defaultSearch = true;
            this.setState({
                SelectedSearch: Value, IsDefaultSearch: defaultSearch
            }, () => { this.FillFilters(id); });
            SelectedUserPreferenceId = id;
        }

    }

    copyToClipboard(inputValue) {
        if ((window as any).clipboardData && (window as any).clipboardData.setData) {
            return (window as any).clipboardData.setData("Text", inputValue);

        } else if (document.queryCommandSupported && document.queryCommandSupported("copy")) {
            var textarea = document.createElement("textarea");
            textarea.textContent = inputValue;
            textarea.style.position = "fixed";
            document.body.appendChild(textarea);
            textarea.select();
            try {
                return document.execCommand("copy");
            } catch (ex) {
                return false;
            } finally {
                document.body.removeChild(textarea);
            }
        }
    }

    PastefromClipboard(inputValue) {
        if (navigator.clipboard != undefined) {
            setTimeout(async () => {
                const clipboardText = await navigator.clipboard.readText();
                this.SetPasteContent(inputValue, clipboardText);

            }, 1000)
        }
        else {
            const clipboardText = (window as any).clipboardData.getData('Text');
            this.SetPasteContent(inputValue, clipboardText);
        }

    }

    SetPasteContent(inputValue, clipboardText) {
        var filters = self.state.Filters;
        if (inputValue[0].id == "txtReeferId")
            filters.SelectedReefer = inputValue.val() + clipboardText.toString();
        else if (inputValue[0].id == "txtBooking")
            filters.SelectedBookingNumber = inputValue.val() + clipboardText.toString();
        this.setState({
            Filters: filters
        });
        inputValue.addClass("fw-semibold");
    }

    static UpdateAdvanceSearchFilters(selectedCCProfile: any) {
        if (self != undefined) {
            self.setState({ Filters: { ...self.state.Filters, SelectedCargoCareProfiles: selectedCCProfile } });
        }
    }

    public render() {
        var Voyagedisabled: any;
        var Calldisabled: any;
        if (this.state.Filters.SelectedVesselCD != "" && this.state.Filters.SelectedVesselCD != null) {
            Voyagedisabled = false;
            Calldisabled = true;
        }
        else {
            Voyagedisabled = true;
            Calldisabled = true;
        }
        if (this.state.Filters.SelectedVoyage != "" && this.state.Filters.SelectedVoyage != null) {
            Calldisabled = false;
        }
        else {
            Calldisabled = true;
        }
        const { suggestionsFenceId, suggestionsVesselId, suggestionsVoyage, suggestionsCalls } = this.state;//WI-26881

        const FenceIdListinputProps = {
            id: 'geofenceID',
            placeholder: 'Geofence ID',
            value: this.state.Filters.SelectedGeofence,
            onChange: this.onChangeFenceId.bind(this)
        };
        const FenceIdListinputPropsforvessel = {
            id: 'vesselID',
            placeholder: 'Vessel',
            value: this.state.Filters.SelectedVesselCD,
            onChange: this.onChangeVesselId.bind(this)
        };
        const FenceIdListinputPropsforvoyage = {
            id: 'voyageNum',
            placeholder: 'Voyage',
            value: this.state.Filters.SelectedVoyage,
            onChange: this.onChangevoyage.bind(this),
            disabled: Voyagedisabled
        };
        const FenceIdListinputPropsforcall = {
            id: 'CallNum',
            placeholder: 'Call',
            value: this.state.Filters.SelectedCall,
            onChange: this.onChangcall.bind(this),
            disabled: Calldisabled
        };
        var searchNamesList = this.state.SearchNamesList;
        var searchNamesListOptions = searchNamesList.map(function (searchNames) {
            var searchName = searchNames.SearchName;
            if (searchNames.DefaultSearch && searchNames.DashboardPreferenceId == self.props.dashboardPreferenceId)
                searchName = searchName + " (Default)";
            return (
                <li className='dropdown-item d-flex' >
                    <div className='asset-dropdown'> <a href="javascript:void(0);" title={searchName} className='asset-dropdown' data-value={searchNames.SearchName} onClick={self.onCreateNewSavedSearch.bind(self, searchNames.SearchName, searchNames.UserPreferenceId, searchNames.DefaultSearch)}>{searchName}</a> </div>
                    <div className='ms-4'> <img src={deletepng} onClick={self.onDeleteConfirmation.bind(self, searchNames.UserPreferenceId, searchNames.SearchName, searchNames.DefaultSearch)} className='dropdown-delete' alt='delete' /> </div>
                </li>
            );
        });

        var assetTypes = this.state.AssetTypes;
        if (assetTypes != undefined && assetTypes != null && assetTypes.length > 0) {
            var assetTypesOptions = assetTypes.map(function (asset) {
                return (
                    { value: asset, label: asset }
                );
            });
        }

        var cargoCareProfiles = this.state.CargoCareProfiles;
        if (cargoCareProfiles != undefined && cargoCareProfiles != null && cargoCareProfiles.length > 0) {

            var cargoCareProfilesOptions = cargoCareProfiles.map(function (CCP) {

                return (
                    { value: CCP.CargoCareCustomerProfileID, label: CCP.CargoCareCustomerProfileCode }
                );
            });
        }
        //RCNG5588
        var pols = this.state.Pols;
        if (pols != undefined && pols != null && pols.length > 0) {

            var polOptions = pols.map(function (POL) {

                return (
                    { value: POL.POL, label: POL.POL }
                );
            });
        }

        var pods = this.state.Pods;
        if (pods != undefined && pods != null && pods.length > 0) {

            var podOptions = pods.map(function (POD) {

                return (
                    { value: POD.POD, label: POD.POD }
                );
            });
        }

        var selectedSearch: string = this.state.SelectedSearch;
        if (selectedSearch.length > 30)
            selectedSearch = selectedSearch.slice(0, 27).concat("...");

        var CustomerTypeCd = JSON.parse(sessionStorage.getItem('customerDetails')).CustomerTypeCd;

        var renderAssetTypesHtml;
        if (assetTypes.length > 1)
            renderAssetTypesHtml = <div className='col-12 mb-2'>
                <Select.Creatable
                    closeOnSelect={!this.state.stayOpen}
                    disabled={this.state.disabled}
                    multi
                    onChange={this.AssetChange.bind(this)}
                    options={assetTypesOptions}
                    placeholder="Asset Types"
                    removeSelected={this.state.removeSelected}
                    rtl={this.state.rtl}
                    simpleValue
                    value={this.state.Filters.SelectedAssetTypes}
                    minMenuHeight={30}
                    maxMenuHeight={30}
                    promptTextCreator={() => false}
                />
            </div>;

        var assetStates = this.state.AssetStates;
        if (assetStates != undefined && assetStates != null && assetStates.length > 0) {
            var assetStatesOptions = assetStates.map(function (states) {
                return (
                    { value: states.value, label: states.label }
                );
            });
        }

        var renderAssetStatesHtml;
        if (assetTypes.indexOf("Reefer") > -1)
            renderAssetStatesHtml = <div className='col-12 mb-2' id="InventoryState">
                <Select.Creatable
                    closeOnSelect={!this.state.stayOpen}
                    disabled={this.state.disabled}
                    multi
                    onChange={this.AssetStateChange.bind(this)}
                    options={assetStatesOptions}
                    placeholder="Inventory State"
                    removeSelected={this.state.removeSelected}
                    rtl={this.state.rtl}
                    simpleValue
                    value={this.state.Filters.SelectedAssetStates}
                    minMenuHeight={30}
                    maxMenuHeight={30}
                    promptTextCreator={() => false}
                />
            </div>;

        return <form className='mt-1' id='AdvanceSearch'>
            <div className='dashboardSearch-scrollbar'>
                <div className='row px-2'>
                    {this.state.SelectedSearchControls != undefined && this.state.SelectedSearchControls != null ? this.state.SelectedSearchControls.map(field => {
                        switch (field) {
                            case "SaveSearch":
                                return (<div className='d-flex col-12 mb-2 mt-2'>

                                    <div className="dropdown flex-grow-1 saved-searches" id="ddlSavedSearch">
                                        <button className="btn-outline-secondary dropdown-toggle btn-sm rounded-top" id="btnSaveSearch" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                            {selectedSearch}
                                        </button>
                                        <ul className="dropdown-menu">
                                            <div className='dropdown-heighit'>
                                            <li className='dropdown-item'><a href="javascript:void(0);" data-value={"New"} onClick={self.onCreateNewSavedSearch.bind(self, "New", 0)}>{"<< Create New Saved Search >>"}</a></li>
                                            {searchNamesListOptions}
                                        </div>
                                        </ul>
                                    </div>

                                    <div id="txtSearchName" className='col-8 flex-grow-1' style={{ display: 'none' }}>
                                        <input type="text" className="form-control SearchName" id="formGroupExampleInput" placeholder="Search Name" value={this.state.SearchName} onChange={this.SearchNameOnchange.bind(this)} />
                                    </div>

                                    <div className="form-check mt-1">
                                        <input className="form-check-input mt-55" type="checkbox" id="flexCheckDefault" name="IsDefault" checked={this.state.IsDefaultSearch} onChange={this.onDefaultCheck.bind(this)} />
                                        <label className="form-check-label" for="flexCheckDefault">
                                            Default
                                        </label>
                                        <i className='fas fa-question-circle information-circle-assetsearch ms-2' title='Click for details'
                                            onClick={this.renderSaveSearchDialog.bind(this)} ></i>
                                    </div>

                                </div>);

                            case "AssetID":
                                return (<div className='col-12 mb-2'>
                                    <ContextMenuTrigger id="txtReeferIdContext">
                                        <textarea id='txtReeferId' className='form-control texarea-55' placeholder='Asset ID(s)' onChange={e => this.ReeferIdschange(e)} value={this.state.Filters.SelectedReefer}></textarea>
                                        <ContextMenu id="txtReeferIdContext">
                                            <MenuItem onClick={e => this.copyToClipboard(this.state.Filters.SelectedReefer)}>Copy</MenuItem>
                                            {!isFirefox ?
                                                <MenuItem onClick={e => this.PastefromClipboard($('#txtReeferId'))}>Paste</MenuItem> : <MenuItem className='hidden'>Paste</MenuItem>}
                                        </ContextMenu>
                                    </ContextMenuTrigger>

                                </div>);
                            case "BookingNumber":
                                return (hasReefers ? <div className='col-12 mb-2'>
                                    <ContextMenuTrigger id="txtBookingContext">
                                        <textarea id='txtBooking' className='form-control texarea-55' placeholder='Active Booking Number(s)' onChange={e => this.BookingNumberchange(e)} value={this.state.Filters.SelectedBookingNumber}></textarea>
                                        <ContextMenu id="txtBookingContext">
                                            <MenuItem onClick={e => this.copyToClipboard(this.state.Filters.SelectedBookingNumber)}>Copy</MenuItem>
                                            {!isFirefox ?
                                                <MenuItem onClick={e => this.PastefromClipboard($('#txtBooking'))}>Paste</MenuItem> : <MenuItem className='hidden'>Paste</MenuItem>}
                                        </ContextMenu>
                                    </ContextMenuTrigger>
                                </div> : '');
                            case "CargoCareProfile":
                                return (
                                    UserRights.checkMenuItemVisibility('247')[0] == "hidden" ? '' :
                                        <div className='col-12 mb-2'>
                                            <Select.Creatable
                                                closeOnSelect={!this.state.stayOpen}
                                                disabled={this.state.disabled}
                                                multi
                                                onChange={this.CargoCareProfileChange.bind(this)}
                                                options={cargoCareProfilesOptions}
                                                placeholder="CargoCare Profile(s)"
                                                removeSelected={this.state.removeSelected}
                                                rtl={this.state.rtl}
                                                simpleValue
                                                value={this.state.Filters.SelectedCargoCareProfiles}
                                                minMenuHeight={30}
                                                maxMenuHeight={30}
                                                promptTextCreator={() => false}
                                            />
                                        </div>);
                            case "GeofenceStatus":
                                return (<div className='col-12 mb-2'>
                                    <select className='form-select ' id='selectInsideGeofence' onChange={e => this.InsideGeofencechange(e)} value={this.state.Filters.SelectedGeofenceInside}>
                                        <option>Geofence Status</option>
                                        <option value="1">Inside Geofence Only</option>
                                        <option value="0">Outside Geofence Only</option>
                                    </select>
                                </div>);
                            case "GeofenceID":
                                return (<div className='col-12 mb-2'>
                                    <Autosuggest name="geofenceID" id="geofenceID"
                                        suggestions={suggestionsFenceId}
                                        onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
                                        onSuggestionsClearRequested={this.onSuggestionsClearRequested}
                                        getSuggestionValue={this.getSuggestionValue}
                                        renderSuggestion={this.renderSuggestion}
                                        inputProps={FenceIdListinputProps}
                                        highlightFirstSuggestion={true}
                                    />
                                </div>);
                            case "AssetTypes":
                                return (assetCount == 1 ? '' : <div className='col-12 mb-2'>
                                    <Select.Creatable
                                        closeOnSelect={!this.state.stayOpen}
                                        disabled={this.state.disabled}
                                        multi
                                        onChange={this.AssetChange.bind(this)}
                                        options={assetTypesOptions}
                                        placeholder="Asset Types"
                                        removeSelected={this.state.removeSelected}
                                        rtl={this.state.rtl}
                                        simpleValue
                                        value={this.state.Filters.SelectedAssetTypes}
                                        minMenuHeight={30}
                                        maxMenuHeight={30}
                                        promptTextCreator={() => false}
                                    />
                                </div>);
                            case "InventoryState":
                                return (showInvState ? <div className='col-12 mb-2' id="InventoryState">
                                    <Select.Creatable
                                        closeOnSelect={!this.state.stayOpen}
                                        disabled={this.state.disabled}
                                        multi
                                        onChange={this.AssetStateChange.bind(this)}
                                        options={assetStatesOptions}
                                        placeholder="Inventory State"
                                        removeSelected={this.state.removeSelected}
                                        rtl={this.state.rtl}
                                        simpleValue
                                        value={this.state.Filters.SelectedAssetStates}
                                        minMenuHeight={30}
                                        maxMenuHeight={30}
                                        promptTextCreator={() => false}
                                    />
                                </div> : '');
                            case "OEM":
                                return ((showInvState) && ((assetTypes.indexOf("Reefer") > -1 || (assetTypes.indexOf("Genset") > -1)))
                                    ? (<div className='col-12 mb-2'>
                                        <select className='form-select ' id='selectOemType' onChange={e => this.Oemchange(e)} value={this.state.Filters.SelectedOem}>
                                            <option>OEM Type</option>
                                            {
                                                this.state.Oemtypes.map((oem, index) =>
                                                    <option key={oem.OEMTypeCD + index} value={oem.OEMTypeCD}>{oem.DisplayName}</option>
                                                )}
                                        </select>
                                    </div>) : "");
                            case "Countries":
                                return (
                                    <div className='col-12 mb-2'>
                                        <select className='form-select ' id='selectRefCountry' onChange={e => this.Countrychange(e)} value={this.state.Filters.SelectedCountry}>
                                            <option>Country</option>
                                            {
                                                this.state.RefCountry.map((item, index) =>
                                                    <option key={item.CountryCd + index} value={item.CountryCd}>{item.CountryName}</option>
                                                )}
                                        </select>
                                    </div>);
                            case "ReportingInterval":
                                return (<div className='col-12 mb-2'>
                                    <select className='form-select ' id='selectReportingInterval' onChange={e => this.ReportingIntervalchange(e)} value={this.state.Filters.SelectedInterval}>
                                        <option>Reporting (min)</option>
                                        <option>10</option>
                                        <option>15</option>
                                        <option>30</option>
                                        <option>60</option>
                                        <option>120</option>
                                        <option>240</option>
                                    </select>
                                </div>);
                            case "VesselCode":
                                return (<div className='col-12 mb-2 hidden'>
                                    <div className='input-group'>
                                        <input type='text' id='txtVesselCode' className='form-control' placeholder='Vessel Code' onChange={e => this.Vesselcodechange(e)} value={this.state.Filters.SelectedVesselCode} />
                                    </div>
                                </div>);

                            case "VesselID":
                                return (<div className="col-4 mb-2" >

                                    <Autosuggest name="vesselID" id="vesselID"
                                        suggestions={suggestionsVesselId}
                                        onSuggestionsFetchRequested={this.onSuggestionsFetchRequestedforvessel}
                                        onSuggestionsClearRequested={this.onSuggestionsClearRequestedforvessel}
                                        getSuggestionValue={this.getSuggestionVesselValue}
                                        renderSuggestion={this.renderSuggestionVesselvalue}
                                        inputProps={FenceIdListinputPropsforvessel}
                                        highlightFirstSuggestion={true}
                                    />

                                </div>);
                            case "Voyage":
                                return (<div className="col-4 mb-2" >

                                    <Autosuggest name="voyage" id="voyage"
                                        suggestions={suggestionsVoyage}
                                        onSuggestionsFetchRequested={this.onSuggestionsFetchRequestedforvoyage}
                                        onSuggestionsClearRequested={this.onSuggestionsClearRequestedforvoyage}
                                        getSuggestionValue={this.getSuggestionvoyageValue}
                                        renderSuggestion={this.renderSuggestionvoyagevalue}
                                        inputProps={FenceIdListinputPropsforvoyage}
                                        highlightFirstSuggestion={true}
                                    />

                                </div>);
                            case "Call":
                                return (<div className="col-4 mb-2" >

                                    <Autosuggest name="Call" id="Call"
                                        suggestions={suggestionsCalls}
                                        onSuggestionsFetchRequested={this.onSuggestionsFetchRequestedforcall}
                                        onSuggestionsClearRequested={this.onSuggestionsClearRequestedforcall}
                                        getSuggestionValue={this.getSuggestioncallValue}
                                        renderSuggestion={this.renderSuggestioncallvalue}
                                        inputProps={FenceIdListinputPropsforcall}
                                        highlightFirstSuggestion={true}
                                    />

                                </div>);
                            //RCNG5588
                            case "POL":
                                return (
                                    /*UserRights.checkMenuItemVisibility('247')[0] == "hidden" ? '' :*/
                                        <div className='col-12 mb-2'>
                                            <Select.Creatable
                                                closeOnSelect={!this.state.stayOpen}
                                                disabled={this.state.disabled}
                                                multi
                                                onChange={this.PolChange.bind(this)}
                                                options={polOptions}
                                                placeholder="POL"
                                                removeSelected={this.state.removeSelected}
                                                rtl={this.state.rtl}
                                                simpleValue
                                                value={this.state.Filters.SelectedPol}
                                                minMenuHeight={30}
                                                maxMenuHeight={30}
                                                promptTextCreator={() => false}
                                                onInputChange={inputValue =>
                                                    (inputValue.length <= 30 ? inputValue : inputValue.substr(0, 30))
                                            }
                                            />
                                    </div>);

                            case "POD":
                                return (
                                    /*UserRights.checkMenuItemVisibility('247')[0] == "hidden" ? '' :*/
                                    <div className='col-12 mb-2'>
                                        <Select.Creatable
                                            closeOnSelect={!this.state.stayOpen}
                                            disabled={this.state.disabled}
                                            multi
                                            onChange={this.PodChange.bind(this)}
                                            options={podOptions}
                                            placeholder="POD"
                                            removeSelected={this.state.removeSelected}
                                            rtl={this.state.rtl}
                                            simpleValue
                                            value={this.state.Filters.SelectedPod}
                                            minMenuHeight={30}
                                            maxMenuHeight={30}
                                            promptTextCreator={() => false}
                                            onInputChange={inputValue =>
                                                (inputValue.length <= 30 ? inputValue : inputValue.substr(0, 30))
                                            }
                                        />
                                    </div>);
                            default:
                                return (
                                    <div></div>
                                );
                        }
                    }) : ''}



                    {this.state.CustomAttributesHtml}
                </div>
            </div>
            <div className='advance-serach-buttons'>
                <button type='button' onClick={this.ClearFilter.bind(this, false)} className='btn btn btn-primary'>Clear</button>
                <button type='button' onClick={this.ApplyFilter.bind(this)} className='btn btn btn-primary  ms-2'>Search</button>

            </div>
        </form>;
    }
}
